<template>
  <form ref="form" class="ortic-form-horizontal">
    <o-card v-if="item" :capExceed="!!item.cap_exceeded"
            :title="$t('sandoz.gadget_contract') + ' // ' + (item.contract_no ? item.contract_no : '-')">
      <b-tabs ref="tabs" v-model="activeTab" class="inline-tabs">
        <b-tab :title="$t('sandoz.general')" active>
          <b-row>
            <b-col>
              <o-value-select v-model="item.user_id" :label="$t('sandoz.owner')"
                              :readonly="readonly" text-field="name"
                              url="/api/system/users?filter%5Bactive%5D=1%25&sortBy=name&include=flm,approval_roles"
                              value-field="id" @input-object="setCurrentUser"></o-value-select>

              <o-form-group :label="$t('sandoz.type')">
                <b-form-select v-if="item.contract_year < 2025" v-model="item.type" :options="contractTypesTf"
                               :readonly="readonly || !!item.id" :disabled="readonly || !!item.id">
                </b-form-select>
                <b-form-select v-else v-model="item.type" :options="contractTypes"
                               :readonly="readonly || !!item.id" :disabled="readonly || !!item.id">
                </b-form-select>
              </o-form-group>

              <o-value-select v-model="item.contract_year" :items="years" :label="$t('sandoz.contract_year')"
                              :readonly="readonly" :title="$t('sandoz.contract_year')"/>

              <o-form-group :label="$t('sandoz.customer_external_id')" class="mb-2">
                <b-input-group>
                  <input v-model="item.customer_external_id" class="form-control" disabled type="text">
                  <b-input-group-append v-if="!readonly">
                    <b-btn variant="primary" @click.prevent="setMasterAddress">
                      <fa icon="ellipsis-h"/>
                    </b-btn>
                  </b-input-group-append>
                </b-input-group>
              </o-form-group>

              <o-datepicker ref="contract_start" v-model="item.contract_start" :disabled="readonly"
                            :errorField="'contract_start'" :label="$t('sandoz.contract_start')" :typeable="true"/>
              <o-datepicker v-model="item.contract_expiration" :disabled="readonly"
                            :errorField="'contract_expiration'" :label="$t('sandoz.contract_expiration')"
                            :typeable="true"
                            class="d-none"/>
              <o-form-group :label="$t('sandoz.new_customer')" class="new_customer_radio">
                <div class="w-100 pl-4 d-flex">
                  <b-form-radio v-model="item.new_customer" name="new_customer" :disabled="readonly" value="x">{{$t('sandoz.yes')}}</b-form-radio>
                  <b-form-radio v-model="item.new_customer" name="new_customer" :disabled="readonly" :value="null">{{$t('sandoz.no')}}</b-form-radio>
                </div>
              </o-form-group>

              <o-form-group :label="$t('sandoz.previous_contract')" class="mb-2"
                            v-if="item.new_customer === null || (this.changeExternalID && item.new_customer === null)"
                            :errorField="'previous_contract'" :class="item.new_customer === null && (item.previous_contract === undefined || item.previous_contract === null || item.previous_contract === '') ? 'has-error' : ''" >
                <b-input-group>
                  <input :value="item.previous && item.previous.contract_no ? item.previous.contract_no : null"
                         type="text" class="form-control"  disabled>
                  <b-input-group-append>
                    <b-btn variant="primary" @click.prevent="$refs.addPreviousContractModel.show()">
                      <fa icon="ellipsis-h"/>
                    </b-btn>
                  </b-input-group-append>
                  <input v-model="item.previous_contract" type="hidden">
                </b-input-group>
              </o-form-group>

              <o-value-select v-model="item.language" :items="languages" :label="$t('sandoz.language')"
                              :readonly="readonly || !!item.id"/>
            </b-col>
            <b-col>
              <o-input v-model="item.invest_max" :append="investMaxPercentage"
                       :errorField="'invest_max'" :label="$t('sandoz.cal_invest_max')" :readonly="true" format="number"
                       type="number"/>
              <input v-model="item.invest_max_percentage" type="hidden"/>

              <template v-if="user.is_super_user">
                <o-textarea v-model="item.super_user_comment"
                            :class="isCommentError && !item.super_user_comment ? 'has-error' : ''"
                            :error-field="'super_user_comment'"
                            :label="$t('sandoz.super_user_comment')"
                            class="mt-3 d-none"></o-textarea>
              </template>
            </b-col>
          </b-row>

          <b-btn @click.prevent="activeTab++">{{ $t('sandoz.next') }}</b-btn>
        </b-tab>
        <b-tab :title="$t('sandoz.addresses')">
          <b-overlay :show="item.customer_external_id == null">

            <div class="d-flex">
              <b-btn @click="addAddress">{{ $t('sandoz.add_address') }}</b-btn>

              <b-input-group-append class="ml-1" :disabled="!item.customer_external_id" v-if="item.type === 'KAM_SD_GADGET'">
                <b-dropdown variant="primary" type="button" split :text="$t('sandoz.add_sub_addresses')" @click.prevent="addSubAddresses">
                  <b-dropdown-item @click.prevent="$refs.subAddressListModal.show()">{{$t('sandoz.add_addresses_from_list')}}</b-dropdown-item>
                </b-dropdown>
              </b-input-group-append>
            </div>

            <div class="table-responsive">
              <table class="table">
                <thead>
                <tr>
                  <th>{{ $t('sandoz.hco') }}</th>
                  <th>{{ $t('sandoz.name') }}</th>
                  <th>{{ $t('sandoz.address') }}</th>
                  <th>{{ $t('sandoz.zip') }}</th>
                  <th>{{ $t('sandoz.city') }}</th>
                  <th>{{ $t('sandoz.customer_external_id') }}</th>
                  <th>{{ $t('sandoz.no_of_hcps') }}</th>
                  <th></th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(address, addressIndex) in item.addresses" :key="addressIndex"
                    :class="{'bg-light': address.address_type === 'master'}">
                  <td>
                    {{ address.company_name }}
                    <o-inline-edit v-if="address.address_type === 'master'" v-model="address.company_name"/>
                  </td>
                  <td>
                    {{ address.name }}
                    <o-inline-edit v-model="address.name"/>
                  </td>
                  <td>
                    {{ address.street }}
                    <o-inline-edit v-if="address.address_type === 'master'" v-model="address.street"/>
                  </td>
                  <td>
                    {{ address.zip }}
                    <o-inline-edit v-if="address.address_type === 'master'" v-model="address.zip"/>
                  </td>
                  <td>
                    {{ address.city }}
                    <o-inline-edit v-if="address.address_type === 'master'" v-model="address.city"/>
                  </td>
                  <td>{{ address.customer_external_id }}</td>
                  <td class="text-nowrap">
                    <template v-if="address.address_type === 'master'">
                      <template v-if="user && !user.is_super_user && address.loaded_number_of_hcps > 0">
                        <div class="w-100">
                          <div class="form-control" readonly="readonly">{{ address.loaded_number_of_hcps }}</div>
                        </div>
                      </template>
                      <template v-else>
                        <b-input v-model.number="address.number_of_hcps" :class="{'border-danger': !address.number_of_hcps}"
                                 class="mw-very-small" step="1" type="number"
                                 @blur.native="setCalculatedInvest()"/>
                      </template>
                    </template>
                  </td>
                  <td class="text-right text-nowrap">
                    <div v-if="addressIndex > 0" aria-label="edit controls" class="btn-group btn-group-sm"
                         role="group">
                      <o-delete text="Are you sure you want to remove this address?"
                                v-on:execute-action="item.addresses.splice(addressIndex, 1)"></o-delete>
                    </div>
                  </td>
                </tr>
                </tbody>
              </table>
            </div>
            <template>
              <o-textarea v-model="item.additional_address_information" :label="$t('sandoz.additional_address_information')"
                          class="mt-3">
              </o-textarea>
            </template>
            <template #overlay>
              <div class="text-center">
                <p>{{ $t('sandoz.set_external_id_first') }}</p>
              </div>
            </template>
          </b-overlay>

          <b-modal ref="subAddressListModal" :title="$t('sandoz.sub_address_list_modal')" scrollable>
            <p>{{$t('sandoz.sub_address_list_modal_text')}}</p>

            <textarea class="form-control" v-model="subAddressList.input" @keyup="updateExternalIDlist">

            </textarea>
            <div v-if="subAddressList.externalIDs.length > 0">
              <hr>
              <table class="w-100">
                <tr v-for="(externalID, index) in subAddressList.externalIDs" :key="index">
                  <td>
                    {{externalID.externalID}}
                  </td>
                  <td class="text-right">
                    <span class="badge badge-success" v-if="externalID.feedback == 'added'">{{$t('sandoz.address_added')}}</span>
                    <span class="badge badge-secondary" v-if="externalID.feedback == 'exists'">{{$t('sandoz.address_already_exists')}}</span>
                    <span class="badge badge-warning" v-if="externalID.feedback == 'not_found'">{{$t('sandoz.address_not_found')}}</span>
                  </td>
                </tr>
              </table>
            </div>

            <template #modal-footer="{ cancel }">
              <b-button variant="secondary" @click="cancel()" class="ml-auto">
                {{$t('core.cancel')}}
              </b-button>
              <b-button variant="primary" @click="addAddressListImp">
                {{$t('sandoz.add_addresses')}}
              </b-button>
            </template>
          </b-modal>

          <b-modal ref="subAddressModal" :title="$t('sandoz.sub_address_modal')">
            <p>{{$t('sandoz.sub_address_modal_text')}}</p>

            <template #modal-footer="{ cancel }">
              <b-button variant="secondary" @click="cancel()" class="ml-auto">
                {{$t('core.cancel')}}
              </b-button>
              <b-button variant="primary" @click="addSubAddressesImpl">
                {{$t('sandoz.append_addresses')}}
              </b-button>
              <b-button variant="primary" @click="clearAndAddSubAddressesImpl">
                {{$t('sandoz.clear_and_append_addresses')}}
              </b-button>
            </template>
          </b-modal>

          <b-btn @click.prevent="activeTab--">{{ $t('sandoz.previous') }}</b-btn>
          <b-btn @click.prevent="activeTab++">{{ $t('sandoz.next') }}</b-btn>
        </b-tab>
        <b-tab :title="$t('sandoz.items')">
          <b-overlay :show="item.type == null">
            <div class="d-flex mb-2 align-items-center">
              <b-link href="https://sandoz.antalis.ch/PrivateLogin" target="_blank" variant="primary">
                {{ $t('sandoz.e_shop') }} <fa icon="fa-link"/>
              </b-link>
            </div>
            <div class="card mb-2">
              <div class="d-flex card-body card-silver p-2">
                <table>
                  <tbody>
                  <tr>
                    <td>{{ $t('sandoz.marketing_activity_total_maximum') }}</td>
                    <td class="text-right">{{ item.marketing_activities_maximum | formatNumber }}</td>
                  </tr>
                  <tr>
                    <td>{{ $t('sandoz.marketing_activity_total_selected_standard') }}</td>
                    <td class="text-right">{{ marketingActivitiesStandard | formatNumber }}</td>
                  </tr>
                  <tr>
                    <td>{{ $t('sandoz.marketing_activity_total_selected_adhoc') }}</td>
                    <td class="text-right">{{ marketingActivitiesAdhoc | formatNumber }}</td>
                  </tr>
                  <tr>
                    <td>{{ $t('sandoz.marketing_activity_total_available') }}</td>
                    <td :class="{'text-danger': Math.sign(marketingActivityAdhocAvailable()) === -1}"
                        class="text-right">
                      {{ marketingActivityAdhocAvailable() | formatNumber }}
                    </td>
                  </tr>
                  </tbody>
                </table>
              </div>
            </div>

            <template v-for="(address, index) in item.addresses">
              <template v-if="address.address_type === 'delivery'">
                <div class="d-flex">
                  <div class="pt-2">
                    <b>
                      {{ address.company_name ? address.company_name + ', ' : '' }}
                      {{ address.name ? address.name + ', ' : '' }}
                      {{ address.street ? address.street + ', ' : '' }}
                      {{ address.zip }} {{ address.city }}
                    </b>
                    <b-badge v-if="address.cap_exceeded" class="ml-2" href="#" pill variant="danger">
                      {{ $t('sandoz.cap_exceeded') }}
                    </b-badge>
                  </div>
                  <div class="ml-auto">
                    <div v-if="!isHCPSet" class="badge badge-danger">{{ $t('sandoz.no_hcps_address') }}
                    </div>
                  </div>
                </div>
                <div v-if="isHCPSet" class="table-responsive mt-3 ml-2 ice-item-table-div">
                  <table class="table table-sm ice-item-table">
                    <thead>
                    <tr>
                      <th class="" scope="col"></th>
                      <th class="mw-400" scope="col">{{ $t('sandoz.item') }}</th>
                      <th scope="col">{{ $t('sandoz.item_price') }}</th>
                      <th scope="col">{{ $t('sandoz.price') }}</th>
                      <th scope="col">{{ $t('sandoz.quantity') }}</th>
                      <th class="text-nowrap" scope="col">{{ $t('sandoz.exists') }}
                        <b-popover :target="`popover-exists-info`" triggers="hover focus">
                          <div v-html="$t('sandoz.exist_info_text_checked')"></div>
                          <div v-html="$t('sandoz.exist_info_text_unchecked')"></div>
                        </b-popover>
                        <fa :id="`popover-exists-info`" icon="circle-info"></fa>
                      </th>
                      <th scope="col">{{ $t('sandoz.qty_1') }}</th>
                      <th scope="col">{{ $t('sandoz.qty_2') }}</th>
                      <th scope="col">{{ $t('sandoz.qty_3') }}</th>
                      <th scope="col">{{ $t('sandoz.qty_4') }}</th>
                      <th scope="col" class="d-none">{{ $t('sandoz.from') }}</th>
                      <th scope="col" class="d-none">{{ $t('sandoz.to') }}</th>
                    </tr>
                    </thead>
                    <tbody v-if="address.items && Object.keys(address.items).length">
                    <template v-for="(line, lineIndex) in address.items">
                      <tr v-if="line.type === 'marketing_activity' && (line.item_visibility === 'both' || line.item_visibility === 'item')" class="master-item">
                        <td>
                          <div v-if="checkLineChildren(line)"
                               class="item-accordion cursor-pointer">
                            <fa v-if="getAccordion(index, lineIndex) === -1" icon="plus"
                                @click="toggleAccordion(index, lineIndex)"/>
                            <fa v-if="getAccordion(index, lineIndex) !== -1" icon="minus"
                                @click="toggleAccordion(index, lineIndex)"/>
                          </div>
                        </td>
                        <td>
                          <div v-if="!line.allow_product_name_to_change">
                            {{ line.product ? line.product.name : line.product_name }}
                            <router-link
                              v-if="user && user.is_super_user && line.product && line.product.product_master_id"
                              :to="{ path: '/sandoz/product_masters/' + line.product.product_master_id }"
                              target="_blank">
                              <fa icon="pencil-alt"/>
                            </router-link>
                            <a v-if="line.product && line.product.info_link"
                               :href="linkValidate(line.product.info_link)"
                               target="_blank">
                              <fa icon="file"/>
                            </a>
                            <fa v-if="line.product && line.product.product_master && line.product.product_master.picture"
                                icon="camera" class="text-primary cursor-pointer" @click="openPictureOverlay(line)"/>
                          </div>
                          <div v-else>
                            <o-input-control v-model="line.product_name" class="full-width mw-95"
                                             type="text"></o-input-control>
                            <router-link
                              v-if="user && user.is_super_user && line.product && line.product.product_master_id"
                              :to="{ path: '/sandoz/product_masters/' + line.product.product_master_id }"
                              target="_blank">
                              <fa icon="pencil-alt"/>
                            </router-link>
                            <a v-if="line.product && line.product.info_link"
                               :href="linkValidate(line.product.info_link)"
                               target="_blank">
                              <fa icon="file"/>
                            </a>
                            <fa v-if="line.product && line.product.product_master && line.product.product_master.picture"
                                icon="camera" class="text-primary cursor-pointer" @click="openPictureOverlay(line)"/>
                          </div>
                        </td>

                        <td class="item-price">{{ line.item_price }}</td>
                        <td>
                          <template
                            v-if="readonly || (line.price_changes && line.price_changes.price_changes === 'no_changes_allowed')">
                            <div class="w-100">
                              <div class="form-control text-right" readonly="readonly">
                                {{ line.price }}
                              </div>
                            </div>
                          </template>
                          <template v-else>
                            <o-input-control v-model="line.price" :ignore-range="true" :step="1" class="form-price"
                                             format="integer" type="number"
                                             @blur="validatePrice(line, index)"></o-input-control>
                          </template>
                        </td>
                        <td>
                          <template v-if="readonly || isReadonly(line, 'yearly')">
                            <div v-if="line.delivery.yearly" class="w-100 form-qty">
                              <div class="form-control" readonly="readonly">{{ line.delivery.yearly.quantity }}</div>
                            </div>
                          </template>
                          <template v-else>
                            <o-input-control v-model="line.delivery.yearly.quantity" :ignore-range="true" :step="1"
                                             class="form-qty"
                                             type="number"
                                             @previous-value="setPreviousQuantity($event, line, 'yearly')"
                                             @blur="setPrice(line, index, 'yearly'), setQuantityToChild(line, 'q1', index)">
                            </o-input-control>
                          </template>
                        </td>
                        <td :class="line && determErrorID.includes(address.id+'-'+line.product.id) ? 'exist_error': ''">
                          <template
                            v-if="line && (line.delivery.yearly.quantity > 0 || line.delivery.q1.quantity > 0 || line.delivery.q2.quantity > 0 || line.delivery.q3.quantity > 0 || line.delivery.q4.quantity > 0)">
                            <template v-if="line.attribute_required || line.exist_value !== null">
                              <b-form-checkbox v-model="line.contract_line_exist_attribute"
                                               :disabled="readonly || line.exist_value !== null"
                                               :indeterminate="line.exist_value === null && !!line.indeterminate">
                              </b-form-checkbox>
                            </template>
                          </template>
                        </td>
                        <td>
                          <template v-if="readonly || isReadonly(line, 'q1')">
                            <div v-if="line.delivery.q1" class="w-100 form-qty">
                              <div
                                :class="{'sync_quarter': line.sync_quarter_q1, 'set-error': line.delivery.q1 && line.delivery.q1.error}"
                                class="form-control"
                                readonly="readonly">
                                {{ line.delivery.q1.quantity }}
                              </div>
                            </div>
                          </template>
                          <template v-else>
                            <o-input-control v-model="line.delivery.q1.quantity"
                                             :class="{'sync_quarter': line.sync_quarter_q1, 'set-error': line.delivery.q1 && line.delivery.q1.error}"
                                             :ignore-range="true"
                                             :step="1"
                                             class="form-qty"
                                             type="number"
                                             @previous-value="setPreviousQuantity($event, line, 'q1')"
                                             @blur="setPrice(line, index, 'q1'), setQuantityToChild(line, 'q1', index)">
                            </o-input-control>
                          </template>
                        </td>
                        <td>
                          <template v-if="readonly || isReadonly(line, 'q2')">
                            <div v-if="line.delivery.q2" class="w-100 form-qty">
                              <div
                                :class="{'sync_quarter': line.sync_quarter_q2, 'set-error': line.delivery.q2 && line.delivery.q2.error}"
                                class="form-control"
                                readonly="readonly">
                                {{ line.delivery.q2.quantity }}
                              </div>
                            </div>
                          </template>
                          <template v-else>
                            <o-input-control v-model="line.delivery.q2.quantity"
                                             :class="{'sync_quarter': line.sync_quarter_q2, 'set-error': line.delivery.q2 && line.delivery.q2.error}"
                                             :ignore-range="true"
                                             :step="1"
                                             class="form-qty"
                                             type="number"
                                             @previous-value="setPreviousQuantity($event, line, 'q2')"
                                             @blur="setPrice(line, index, 'q2'), setQuantityToChild(line, 'q2', index)">
                            </o-input-control>
                          </template>
                        </td>
                        <td>
                          <template v-if="readonly || isReadonly(line, 'q3')">
                            <div v-if="line.delivery.q3" class="w-100 form-qty">
                              <div
                                :class="{'sync_quarter': line.sync_quarter_q3, 'set-error': line.delivery.q3 && line.delivery.q3.error}"
                                class="form-control"
                                readonly="readonly">
                                {{ line.delivery.q3.quantity }}
                              </div>
                            </div>
                          </template>
                          <template v-else>
                            <o-input-control v-model="line.delivery.q3.quantity"
                                             :class="{'sync_quarter': line.sync_quarter_q3, 'set-error': line.delivery.q3 && line.delivery.q3.error}"
                                             :ignore-range="true"
                                             :step="1"
                                             class="form-qty"
                                             type="number"
                                             @previous-value="setPreviousQuantity($event, line, 'q3')"
                                             @blur="setPrice(line, index, 'q3'), setQuantityToChild(line, 'q3', index)">
                            </o-input-control>
                          </template>
                        </td>
                        <td>
                          <template v-if="readonly || isReadonly(line, 'q4')">
                            <div v-if="line.delivery.q4" class="w-100 form-qty">
                              <div
                                :class="{'sync_quarter': line.sync_quarter_q4, 'set-error': line.delivery.q4 && line.delivery.q4.error}"
                                class="form-control"
                                readonly="readonly">
                                {{ line.delivery.q4.quantity }}
                              </div>
                            </div>
                          </template>
                          <template v-else>
                            <o-input-control v-model="line.delivery.q4.quantity"
                                             :class="{'sync_quarter': line.sync_quarter_q4, 'set-error': line.delivery.q4 && line.delivery.q4.error}"
                                             :ignore-range="true"
                                             :step="1"
                                             class="form-qty"
                                             type="number"
                                             @previous-value="setPreviousQuantity($event, line, 'q4')"
                                             @blur="setPrice(line, index, 'q4'), setQuantityToChild(line, 'q4', index)">
                            </o-input-control>
                          </template>
                        </td>
                        <td
                          :class="line && fromDateErrorID.includes(address.id+'-'+line.product.id) ? 'exist_error d-none': 'd-none'">
                          <o-value-select-control v-model="line.valid_from_month" :items="months"
                                                  :readonly="readonly || !line.allow_manual_date_entry"
                                                  @change.native="setDateToChildren(line, index), setDateChanged(line, 'from')">
                          </o-value-select-control>
                        </td>
                        <td class="d-none">
                          <o-value-select-control v-model="line.valid_to_month" :items="months"
                                                  :readonly="readonly || !line.allow_manual_date_entry"
                                                  @change.native="setDateToChildren(line, index, 'to'), setDateChanged(line, 'to')">
                          </o-value-select-control>
                        </td>
                      </tr>
                      <template
                        v-if="line.type === 'marketing_activity' && line.children && Object.keys(line.children).length">
                        <template v-for="(subLine, subLineIndex) in line.children">
                          <template v-if="subLine.item_visibility === 'both' || subLine.item_visibility === 'item'">
                            <tr
                              :class="{'d-none': (getAccordion(index, lineIndex) === -1)}">
                              <td>
                                <div class="item-accordion cursor-pointer sub-accordion-icon"
                                    v-if="checkLineChildren(subLine)">
                                  <fa icon="plus" @click="toggleAccordion(lineIndex, subLineIndex)"
                                      v-if="getAccordion(lineIndex, subLineIndex) === -1"/>
                                  <fa icon="minus" @click="toggleAccordion(lineIndex, subLineIndex)"
                                      v-if="getAccordion(lineIndex, subLineIndex) !== -1"/>
                                </div>
                              </td>
                              <td v-if="!subLine.allow_product_name_to_change" class="indention">
                                {{ subLine.product ? subLine.product.name : subLine.product_name }}
                                <router-link
                                  v-if="user && user.is_super_user && subLine.product && subLine.product.product_master_id"
                                  :to="{ path: '/sandoz/product_masters/' + subLine.product.product_master_id }"
                                  target="_blank">
                                  <fa icon="pencil-alt"/>
                                </router-link>
                                <a v-if="subLine.product && subLine.product.info_link"
                                   :href="linkValidate(subLine.product.info_link)"
                                   target="_blank">
                                  <fa icon="file"/>
                                </a>
                                <fa v-if="subLine.product && subLine.product.product_master && subLine.product.product_master.picture"
                                    icon="camera" class="text-primary cursor-pointer" @click="openPictureOverlay(subLine)"/>
                              </td>
                              <td v-else class="indention">
                                <o-input-control v-model="subLine.product_name" class="full-width mw-95"
                                                 type="text" :readonly="readonly"></o-input-control>
                                <router-link
                                  v-if="user && user.is_super_user && subLine.product && subLine.product.product_master_id"
                                  :to="{ path: '/sandoz/product_masters/' + subLine.product.product_master_id }"
                                  target="_blank">
                                  <fa icon="pencil-alt"/>
                                </router-link>
                                <a v-if="subLine.product && subLine.product.info_link"
                                   :href="linkValidate(subLine.product.info_link)"
                                   target="_blank">
                                  <fa icon="file"/>
                                </a>
                                <fa v-if="subLine.product && subLine.product.product_master && subLine.product.product_master.picture"
                                    icon="camera" class="text-primary cursor-pointer" @click="openPictureOverlay(subLine)"/>
                              </td>
                              <td class="item-price">{{ subLine.item_price  }}</td>
                              <td>
                                <template
                                  v-if="readonly || (subLine.price_changes && subLine.price_changes.price_changes === 'no_changes_allowed')">
                                  <div class="w-100">
                                    <div class="form-control text-right" readonly="readonly">
                                      {{ subLine.price | formatInteger }}
                                    </div>
                                  </div>
                                </template>
                                <template v-else>
                                  <o-input-control v-model="subLine.price" :ignore-range="true" :step="1"
                                                   class="form-price"
                                                   format="integer" type="number"
                                                   @blur="validatePrice(subLine, index)"></o-input-control>
                                </template>
                              </td>
                              <td>
                                <template v-if="readonly || isReadonly(subLine, 'yearly')">
                                  <div v-if="subLine.delivery.yearly" class="w-100 form-qty">
                                    <div class="form-control" readonly="readonly">{{ subLine.delivery.yearly.quantity }}
                                    </div>
                                  </div>
                                </template>
                                <template v-else>
                                  <o-input-control v-model="subLine.delivery.yearly.quantity" :ignore-range="true"
                                                   :step="1"
                                                   class="form-qty"
                                                   type="number"
                                                   @previous-value="setPreviousQuantity($event, subLine, 'yearly')"
                                                   @blur="setQuantityToParent(line, subLine, 'yearly', index),
                                                   setQuantityToChild(subLine, 'yearly', subLineIndex),
                                                   setBoxQuantity(line, 'yearly', subLine.box_or_gadget, index)
                                                   setQuantityToChildSpecial(line, 'yearly', index)">
                                  </o-input-control>
                                </template>
                              </td>
                              <td :class="determErrorID.includes(address.id+'-'+subLine.product.id) ? 'exist_error': ''">
                                <template
                                  v-if="subLine.delivery.yearly.quantity > 0 || subLine.delivery.q1.quantity > 0 || subLine.delivery.q2.quantity > 0 || subLine.delivery.q3.quantity > 0 || subLine.delivery.q4.quantity > 0">
                                  <template v-if="subLine.attribute_required || subLine.exist_value !== null">
                                    <b-form-checkbox v-model="subLine.contract_line_exist_attribute"
                                                     :disabled="readonly || subLine.exist_value !== null"
                                                     :indeterminate="subLine.exist_value === null && !!subLine.indeterminate">
                                    </b-form-checkbox>
                                  </template>
                                </template>
                              </td>
                              <td>
                                <template v-if="readonly || isReadonly(subLine, 'q1', true)">
                                  <div v-if="subLine.delivery.q1" class="w-100 form-qty">
                                    <div
                                      :class="{'sync_quarter': subLine.sync_quarter_q1, 'set-error': subLine.delivery.q1 && subLine.delivery.q1.error}"
                                      class="form-control"
                                      readonly="readonly">
                                      {{ subLine.delivery.q1.quantity }}
                                    </div>
                                  </div>
                                </template>
                                <template v-else>
                                  <o-input-control v-model="subLine.delivery.q1.quantity"
                                                   :class="{'sync_quarter': subLine.sync_quarter_q1, 'set-error': subLine.delivery.q1 && subLine.delivery.q1.error}"
                                                   :ignore-range="true"
                                                   :step="1"
                                                   class="form-qty"
                                                   type="number"
                                                   @previous-value="setPreviousQuantity($event, subLine, 'q1')"
                                                   @blur="setQuantityToParent(line, subLine, 'q1', index),
                                                   setQuantityToChild(subLine, 'q1', subLineIndex),
                                                   setBoxQuantity(line, 'q1', subLine.box_or_gadget, index)
                                                   setQuantityToChildSpecial(line, 'q1', index)">
                                  </o-input-control>
                                </template>
                              </td>
                              <td>
                                <template v-if="readonly || isReadonly(subLine, 'q2', true)">
                                  <div v-if="subLine.delivery.q2" class="w-100 form-qty">
                                    <div
                                      :class="{'sync_quarter': subLine.sync_quarter_q2, 'set-error': subLine.delivery.q2 && subLine.delivery.q2.error}"
                                      class="form-control"
                                      readonly="readonly">
                                      {{ subLine.delivery.q2.quantity }}
                                    </div>
                                  </div>
                                </template>
                                <template v-else>
                                  <o-input-control v-model="subLine.delivery.q2.quantity"
                                                   :class="{'sync_quarter': subLine.sync_quarter_q2, 'set-error': subLine.delivery.q2 && subLine.delivery.q2.error}"
                                                   :ignore-range="true"
                                                   :step="1"
                                                   class="form-qty"
                                                   type="number"
                                                   @previous-value="setPreviousQuantity($event, subLine, 'q2')"
                                                   @blur="setQuantityToParent(line, subLine, 'q2', index),
                                                   setQuantityToChild(subLine, 'q2', subLineIndex),
                                                   setBoxQuantity(line, 'q2', subLine.box_or_gadget, index)
                                                   setQuantityToChildSpecial(line, 'q2', index)">
                                  </o-input-control>
                                </template>
                              </td>
                              <td>
                                <template v-if="readonly || isReadonly(subLine, 'q3', true)">
                                  <div v-if="subLine.delivery.q3" class="w-100 form-qty">
                                    <div :class="subLine.sync_quarter_q3 ? 'sync_quarter' : ''" class="form-control"
                                         readonly="readonly">
                                      {{ subLine.delivery.q3.quantity }}
                                    </div>
                                  </div>
                                </template>
                                <template v-else>
                                  <o-input-control v-model="subLine.delivery.q3.quantity"
                                                   :class="{'sync_quarter': subLine.sync_quarter_q3, 'set-error': subLine.delivery.q3 && subLine.delivery.q3.error}"
                                                   :ignore-range="true"
                                                   :step="1"
                                                   class="form-qty"
                                                   type="number"
                                                   @previous-value="setPreviousQuantity($event, subLine, 'q3')"
                                                   @blur="setQuantityToParent(line, subLine, 'q3', index)
                                                   setQuantityToChild(subLine, 'q3', subLineIndex)
                                                   setBoxQuantity(line, 'q3', subLine.box_or_gadget, index)
                                                   setQuantityToChildSpecial(line, 'q3', index)">
                                  </o-input-control>
                                </template>
                              </td>
                              <td>
                                <template v-if="readonly || isReadonly(subLine, 'q4', true)">
                                  <div v-if="subLine.delivery.q4" class="w-100 form-qty">
                                    <div :class="subLine.sync_quarter_q4 ? 'sync_quarter' : ''"
                                         class="form-control form-qty"
                                         readonly="readonly">
                                      {{ subLine.delivery.q4.quantity }}
                                    </div>
                                  </div>
                                </template>
                                <template v-else>
                                  <o-input-control v-model="subLine.delivery.q4.quantity"
                                                   :class="{'sync_quarter': subLine.sync_quarter_q4, 'set-error': subLine.delivery.q4 && subLine.delivery.q4.error}"
                                                   :ignore-range="true"
                                                   :step="1"
                                                   class="form-qty"
                                                   type="number"
                                                   @previous-value="setPreviousQuantity($event, subLine, 'q4')"
                                                   @blur="setQuantityToParent(line, subLine, 'q4', index),
                                                   setQuantityToChild(subLine, 'q4', subLineIndex),
                                                   setBoxQuantity(line, 'q4', subLine.box_or_gadget, index)
                                                  setQuantityToChildSpecial(line, 'q4', index)">
                                  </o-input-control>
                                </template>
                              </td>
                              <td
                                :class="{'exist_error': (subLine && fromDateErrorID.includes(address.id+'-'+subLine.product.id)), 'd-none': true}">
                                <div
                                  :class="{'d-none': (!!!subLine.delivery.yearly.quantity && !!!subLine.delivery.q1.quantity && !!!subLine.delivery.q2.quantity && !!!subLine.delivery.q3.quantity && !!!subLine.delivery.q4.quantity)}">
                                  <o-value-select-control v-model="subLine.valid_from_month" :items="months"
                                                          :readonly="readonly || !subLine.allow_manual_date_entry"
                                                          @change.native="setDateToChildren(subLine, index, 'from'), setDateChanged(subLine, 'from')">
                                  </o-value-select-control>
                                </div>
                              </td>
                              <td class="d-none">
                                <div
                                  :class="{'d-none': (!!!subLine.delivery.yearly.quantity && !!!subLine.delivery.q1.quantity && !!!subLine.delivery.q2.quantity && !!!subLine.delivery.q3.quantity && !!!subLine.delivery.q4.quantity)}">
                                  <o-value-select-control v-model="subLine.valid_to_month" :items="months"
                                                          :readonly="readonly || !subLine.allow_manual_date_entry"
                                                          @change.native="setDateToChildren(subLine, index, 'to'), setDateChanged(subLine, 'to')">
                                  </o-value-select-control>
                                </div>
                              </td>
                              <td class="text-right text-nowrap">
                              </td>
                            </tr>
                          </template>
                          <template
                            v-if="line.type === 'marketing_activity' && subLine.children && Object.keys(subLine.children).length">
                            <template v-for="(childLine, childLineIndex) in subLine.children">
                              <template v-if="childLine.item_visibility === 'both' || childLine.item_visibility === 'item'">
                                <tr :class="{'d-none': (getAccordion(lineIndex, subLineIndex) === -1 ||  getAccordion(index, lineIndex) === -1)}">
                                  <td></td>
                                  <td v-if="!childLine.allow_product_name_to_change" class="indention-1">
                                    {{ childLine.product ? childLine.product.name : childLine.product_name }}
                                    <router-link
                                      v-if="user && user.is_super_user && childLine.product && childLine.product.product_master_id"
                                      :to="{ path: '/sandoz/product_masters/' + childLine.product.product_master_id }"
                                      target="_blank">
                                      <fa icon="pencil-alt"/>
                                    </router-link>
                                    <a v-if="childLine.product && childLine.product.info_link"
                                       :href="linkValidate(childLine.product.info_link)"
                                       target="_blank">
                                      <fa icon="file"/>
                                    </a>
                                    <fa v-if="childLine.product && childLine.product.product_master && childLine.product.product_master.picture"
                                        icon="camera" class="text-primary cursor-pointer" @click="openPictureOverlay(childLine)"/>
                                  </td>
                                  <td v-else class="indention-1">
                                    <o-input-control v-model="childLine.product_name" class="full-width mw-95"
                                                     type="text" :readonly="readonly"></o-input-control>
                                    <router-link
                                      v-if="user && user.is_super_user && childLine.product && childLine.product.product_master_id"
                                      :to="{ path: '/sandoz/product_masters/' + childLine.product.product_master_id }"
                                      target="_blank">
                                      <fa icon="pencil-alt"/>
                                    </router-link>
                                    <a v-if="childLine.product && childLine.product.info_link"
                                       :href="linkValidate(childLine.product.info_link)"
                                       target="_blank">
                                      <fa icon="file"/>
                                    </a>
                                    <fa v-if="childLine.product && childLine.product.product_master && childLine.product.product_master.picture"
                                        icon="camera" class="text-primary cursor-pointer" @click="openPictureOverlay(childLine)"/>
                                  </td>
                                  <td class="item-price">{{ childLine.item_price }}</td>
                                  <td>
                                    <template
                                      v-if="readonly || (childLine.price_changes && childLine.price_changes.price_changes === 'no_changes_allowed')">
                                      <div class="w-100">
                                        <div class="form-control text-right" readonly="readonly">
                                          {{ childLine.price | formatInteger }}
                                        </div>
                                      </div>
                                    </template>
                                    <template v-else>
                                      <o-input-control v-model="childLine.price" :ignore-range="true" :step="1"
                                                       class="form-price"
                                                       format="integer" type="number"
                                                       @blur="validatePrice(childLine, index)"></o-input-control>
                                    </template>
                                  </td>
                                  <td>
                                    <template v-if="readonly || isReadonly(childLine, 'yearly')">
                                      <div v-if="childLine.delivery.yearly" class="w-100 form-qty">
                                        <div class="form-control" readonly="readonly">
                                          {{ childLine.delivery.yearly.quantity }}
                                        </div>
                                      </div>
                                    </template>
                                    <template v-else-if="childLine.delivery.yearly">
                                      <o-input-control v-model="childLine.delivery.yearly.quantity" :ignore-range="true"
                                                       :step="1"
                                                       class="form-qty"
                                                       type="number"
                                                       @previous-value="setPreviousQuantity($event, childLine, 'yearly')"
                                                       @blur="setQuantityToParent(subLine, childLine, 'yearly', index),
                                                       setBoxQuantity(line, 'yearly', childLine.box_or_gadget, index)">
                                      </o-input-control>
                                    </template>
                                  </td>
                                  <td
                                    :class="determErrorID.includes(address.id+'-'+childLine.product.id)? 'exist_error': ''">
                                    <template
                                      v-if="childLine.delivery.yearly.quantity > 0 || childLine.delivery.q1.quantity > 0 || childLine.delivery.q2.quantity > 0 || childLine.delivery.q3.quantity > 0 || childLine.delivery.q4.quantity > 0">
                                      <template
                                        v-if="childLine.attribute_required || childLine.exist_value !== null">
                                        <b-form-checkbox v-model="childLine.contract_line_exist_attribute"
                                                         :disabled="readonly || childLine.exist_value !== null"
                                                         :indeterminate="childLine.exist_value === null && !!childLine.indeterminate">
                                        </b-form-checkbox>
                                      </template>
                                    </template>
                                  </td>
                                  <td>
                                    <template v-if="readonly || isReadonly(childLine, 'q1', true)">
                                      <div v-if="childLine.delivery.q1" class="w-100 form-qty">
                                        <div :class="childLine.sync_quarter_q1 ? 'sync_quarter' : ''" class="form-control"
                                             readonly="readonly">
                                          {{ childLine.delivery.q1.quantity }}
                                        </div>
                                      </div>
                                    </template>
                                    <template v-else>
                                      <o-input-control v-model="childLine.delivery.q1.quantity" :ignore-range="true"
                                                       :step="1"
                                                       class="form-qty"
                                                       type="number"
                                                       @previous-value="setPreviousQuantity($event, childLine, 'q1')"
                                                       @blur="setQuantityToParent(subLine, childLine, 'q1', index),
                                                       setBoxQuantity(line, 'q1', childLine.box_or_gadget, index)">
                                      </o-input-control>
                                    </template>
                                  </td>
                                  <td>
                                    <template v-if="readonly || isReadonly(childLine, 'q2', true)">
                                      <div v-if="childLine.delivery.q2" class="w-100 form-qty">
                                        <div :class="childLine.sync_quarter_q2 ? 'sync_quarter' : ''" class="form-control"
                                             readonly="readonly">
                                          {{ childLine.delivery.q2.quantity }}
                                        </div>
                                      </div>
                                    </template>
                                    <template v-else>
                                      <o-input-control v-model="childLine.delivery.q2.quantity" :ignore-range="true"
                                                       :step="1"
                                                       class="form-qty"
                                                       type="number"
                                                       @previous-value="setPreviousQuantity($event, childLine, 'q2')"
                                                       @blur="setQuantityToParent(subLine, childLine, 'q2', index),
                                                       setBoxQuantity(line, 'q2', childLine.box_or_gadget, index)">
                                      </o-input-control>
                                    </template>
                                  </td>
                                  <td>
                                    <template v-if="readonly || isReadonly(childLine, 'q3', true)">
                                      <div v-if="childLine.delivery.q3" class="w-100 form-qty">
                                        <div :class="childLine.sync_quarter_q3 ? 'sync_quarter' : ''" class="form-control"
                                             readonly="readonly">
                                          {{ childLine.delivery.q3.quantity }}
                                        </div>
                                      </div>
                                    </template>
                                    <template v-else>
                                      <o-input-control v-model="childLine.delivery.q3.quantity" :ignore-range="true"
                                                       :step="1"
                                                       class="form-qty"
                                                       type="number"
                                                       @previous-value="setPreviousQuantity($event, childLine, 'q3')"
                                                       @blur="setQuantityToParent(subLine, childLine, 'q3', index),
                                                       setBoxQuantity(line, 'q3', childLine.box_or_gadget, index)">
                                      </o-input-control>
                                    </template>
                                  </td>
                                  <td>
                                    <template v-if="readonly || isReadonly(childLine, 'q4', true)">
                                      <div v-if="childLine.delivery.q4" class="w-100 form-qty">
                                        <div :class="childLine.sync_quarter_q4 ? 'sync_quarter' : ''"
                                             class="form-control form-qty"
                                             readonly="readonly">
                                          {{ childLine.delivery.q4.quantity }}
                                        </div>
                                      </div>
                                    </template>
                                    <template v-else>
                                      <o-input-control v-model="childLine.delivery.q4.quantity" :ignore-range="true"
                                                       :step="1"
                                                       class="form-qty"
                                                       type="number"
                                                       @previous-value="setPreviousQuantity($event, childLine, 'q4')"
                                                       @blur="setQuantityToParent(subLine, childLine, 'q4', index),
                                                       setBoxQuantity(line, 'q4', childLine.box_or_gadget, index)">
                                      </o-input-control>
                                    </template>
                                  </td>
                                  <td
                                    :class="{ 'exist_error': (childLine && fromDateErrorID.includes(address.id+'-'+childLine.product.id)), 'd-none': true}">
                                    <div
                                      :class="{'d-none': (!!!childLine.delivery.yearly.quantity && !!!childLine.delivery.q1.quantity && !!!childLine.delivery.q2.quantity && !!!childLine.delivery.q3.quantity && !!!childLine.delivery.q4.quantity)}">
                                      <o-value-select-control v-model="childLine.valid_from_month" :items="months"
                                                              :readonly="readonly || !childLine.allow_manual_date_entry"
                                                              @change.native="setPrice(childLine, index), setDateChanged(childLine, 'from')">
                                      </o-value-select-control>
                                    </div>
                                  </td>
                                  <td class="d-none">
                                    <div
                                      :class="{'d-none': (!!!childLine.delivery.yearly.quantity && !!!childLine.delivery.q1.quantity && !!!childLine.delivery.q2.quantity && !!!childLine.delivery.q3.quantity && !!!childLine.delivery.q4.quantity)}">
                                      <o-value-select-control v-model="childLine.valid_to_month" :items="months"
                                                              :readonly="readonly || !childLine.allow_manual_date_entry"
                                                              @change.native="setPrice(childLine, index), setDateChanged(childLine, 'to')">
                                      </o-value-select-control>
                                    </div>
                                  </td>
                                </tr>
                              </template>
                            </template>
                          </template>
                        </template>
                      </template>
                    </template>
                    </tbody>
                    <tbody v-else>
                    <tr>
                      <td align="center" colspan="11">{{ $t('core.no_records') }}</td>
                    </tr>
                    </tbody>
                  </table>
                </div>
                <div v-else-if="!isHCPSet">
                  <div class="text-center">
                    <p>{{ $t('sandoz.set_hcps_first') }}</p>
                  </div>
                </div>
              </template>
            </template>
            <template #overlay>
              <div class="text-center">
                <p>{{ $t('sandoz.set_type_first') }}</p>
              </div>
            </template>
          </b-overlay>
          <b-btn @click.prevent="activeTab--">{{ $t('sandoz.previous') }}</b-btn>
          <b-btn @click.prevent="activeTab++">{{ $t('sandoz.next') }}</b-btn>
        </b-tab>
        <b-tab :title="$t('sandoz.adhoc_items')">
          <b-overlay :show="item.type == null">
            <div class="card mb-2">
              <div class="d-flex card-body card-silver p-2">
                <table>
                  <tbody>
                  <tr>
                    <td>{{ $t('sandoz.marketing_activity_total_maximum') }}</td>
                    <td class="text-right">{{ item.marketing_activities_maximum | formatNumber }}</td>
                  </tr>
                  <tr>
                    <td>{{ $t('sandoz.marketing_activity_total_selected_standard') }}</td>
                    <td class="text-right">{{ marketingActivitiesStandard | formatNumber }}</td>
                  </tr>
                  <tr>
                    <td>{{ $t('sandoz.marketing_activity_total_selected_adhoc') }}</td>
                    <td class="text-right">{{ marketingActivitiesAdhoc | formatNumber }}</td>
                  </tr>
                  <tr>
                    <td>{{ $t('sandoz.marketing_activity_total_available') }}</td>
                    <td :class="{'text-danger': Math.sign(marketingActivityAdhocAvailable()) === -1}"
                        class="text-right">
                      {{ marketingActivityAdhocAvailable() | formatNumber }}
                    </td>
                  </tr>
                  </tbody>
                </table>
              </div>
            </div>

            <template v-for="(address, index) in item.addresses">
              <template v-if="address.address_type === 'delivery'">
                <div class="d-flex">
                  <div class="pt-2">
                    <b>
                      {{ address.company_name ? address.company_name + ', ' : '' }}
                      {{ address.name ? address.name + ', ' : '' }}
                      {{ address.street ? address.street + ', ' : '' }}
                      {{ address.zip }} {{ address.city }}
                    </b>
                    <b-btn size="sm" type="button" class="ml-2" @click="showItems(index)">
                      <fa icon="plus"/>
                    </b-btn>
                    <b-badge v-if="address.cap_exceeded" class="ml-2" href="#" pill variant="danger">
                      {{ $t('sandoz.cap_exceeded') }}
                    </b-badge>
                  </div>
                  <div class="ml-auto">
                    <div v-if="!isHCPSet" class="badge badge-danger">{{ $t('sandoz.no_hcps_address') }}
                    </div>
                  </div>
                </div>
                <div v-if="isHCPSet" class="table-responsive mt-3 ml-2 ice-item-table-div">
                  <table class="table table-sm ice-item-table">
                    <thead>
                    <tr>
                      <th class="mw-400" scope="col">{{ $t('sandoz.item') }}</th>
                      <th scope="col">{{ $t('sandoz.note') }}</th>
                      <th scope="col">{{ $t('sandoz.item_price') }}</th>
                      <th scope="col">{{ $t('sandoz.price') }}</th>
                      <th scope="col">{{ $t('sandoz.quantity') }}</th>
                      <th scope="col">{{ $t('sandoz.plan_date') }}
                        <b-popover :target="`popover-delivery-plan-info-` + index" triggers="hover focus">
                          <div v-html="$t('sandoz.delivery_plan_info')"></div>
                        </b-popover>
                        <fa :id="`popover-delivery-plan-info-` + index" icon="circle-info"></fa>
                      </th>
                      <th scope="col">{{ $t('sandoz.execute_date') }}
                        <b-popover :target="`popover-delivery-initiated-info-` + index" triggers="hover focus">
                          <div v-html="$t('sandoz.delivery_initiated_info')"></div>
                        </b-popover>
                        <fa :id="`popover-delivery-initiated-info-` + index" icon="circle-info"></fa>
                      </th>
                      <th></th>
                    </tr>
                    </thead>
                    <tbody v-if="address.adhoc_items && Object.keys(address.adhoc_items).length">
                    <template v-for="(line, lineIndex) in address.adhoc_items">
                      <template v-if="line.item_visibility === 'both' || line.item_visibility === 'adhoc_item'">
                        <tr class="master-item">
                          <td>
                            <div v-if="!line.allow_product_name_to_change">
                              {{ line.product ? line.product.name : line.product_name }}
                              <template v-if="user && user.is_super_user">{{line.product ? ' (' + line.product.product_id + ')': ''}}</template>
                              <router-link
                                v-if="user && user.is_super_user && line.product && line.product.product_master_id"
                                :to="{ path: '/sandoz/product_masters/' + line.product.product_master_id }"
                                target="_blank">
                                <fa icon="pencil-alt"/>
                              </router-link>
                              <a v-if="line.product && line.product.info_link"
                                 :href="linkValidate(line.product.info_link)"
                                 target="_blank">
                                <fa icon="file"/>
                              </a>
                              <fa v-if="line.product && line.product.product_master && line.product.product_master.picture"
                                  icon="camera" class="text-primary cursor-pointer" @click="openPictureOverlay(line)"/>
                            </div>
                            <div v-else>
                              <o-input-control v-model="line.product_name" class="full-width mw-95"
                                               type="text" :readonly="line.delivery && line.delivery.yearly.planned_delivery"></o-input-control>
                              <template v-if="user && user.is_super_user">{{line.product ? ' (' + line.product.product_id + ')': ''}}</template>
                              <router-link
                                v-if="user && user.is_super_user && line.product && line.product.product_master_id"
                                :to="{ path: '/sandoz/product_masters/' + line.product.product_master_id }"
                                target="_blank">
                                <fa icon="pencil-alt"/>
                              </router-link>
                              <a v-if="line.product && line.product.info_link"
                                 :href="linkValidate(line.product.info_link)"
                                 target="_blank">
                                <fa icon="file"/>
                              </a>
                              <fa v-if="line.product && line.product.product_master && line.product.product_master.picture"
                                  icon="camera" class="text-primary cursor-pointer" @click="openPictureOverlay(line)"/>
                            </div>
                          </td>
                          <td>
                            {{ line.note }}
                            <o-inline-edit v-model="line.note" @input="disableUploadButton = false"/>
                          </td>
                          <td class="item-price">{{ line.item_price }}</td>
                          <td>
                            <template
                              v-if="(line.price_changes && line.price_changes.price_changes === 'no_changes_allowed') || (line.delivery && line.delivery.yearly.planned_delivery)">
                              <div class="w-100">
                                <div class="form-control text-right" readonly="readonly">
                                  {{ line.price }}
                                </div>
                              </div>
                            </template>
                            <template v-else>
                              <o-input-control v-model="line.price" :ignore-range="true" :step="1" class="form-price"
                                               format="integer" type="number"
                                               @blur="validatePrice(line, index)"></o-input-control>
                            </template>
                          </td>
                          <td>
                            <!-- <template v-if="line.delivery">
                              <div class="w-100 form-qty">
                                <div class="form-control" readonly="readonly">
                                  {{ line.delivery.yearly.quantity }}
                                </div>
                              </div>
                            </template>
                            <template v-else> -->
                              <o-input-control v-model="line.delivery.yearly.quantity" :ignore-range="true" :step="1"
                                               @previous-value="setPreviousQuantity($event, line, 'yearly')"
                                               class="form-qty" type="number" @blur="setPrice(line, index, 'yearly'), disableUploadButton = false">
                              </o-input-control>
                            <!-- </template> -->
                          </td>
                          <td>
                            <template v-if="(line.product && line.product.product_master && line.product.product_master.adhoc_delivery_per_quarter)">
                              <o-value-select-control v-model="line.delivery.yearly.planned_delivery" :items="quarterDates" @input="disableUploadButton = false"></o-value-select-control>
                            </template>
                            <template v-else> 
                              {{line.delivery.yearly.planned_delivery | formatDate }}
                            </template>  
                          </td>
                          <td>{{line.delivery.yearly.delivery_executed | formatDate}}</td>
                          <td>
                            <b-button type="button" size="sm" class="btn btn-secondary"
                                      @click="removeAdhocItem(address, lineIndex)">
                              <fa icon="times"/>
                            </b-button>
                          </td>
                        </tr>
                      </template>
                    </template>
                    </tbody>
                  </table>
                </div>
                <div v-else-if="!isHCPSet">
                  <div class="text-center">
                    <p>{{ $t('sandoz.set_hcps_first') }}</p>
                  </div>
                </div>
              </template>
            </template>
            <template #overlay>
              <div class="text-center">
                <p>{{ $t('sandoz.set_type_first') }}</p>
              </div>
            </template>
          </b-overlay>
          <b-btn @click.prevent="activeTab--">{{ $t('sandoz.previous') }}</b-btn>
        </b-tab>
      </b-tabs>
      <silent-box :gallery="pictures" :lazy-loading="true" class="silentbox-overlay-only" ref="imageSilentBox">
      </silent-box>
      <address-search ref="addressSearch" contract-type="gadget"
                      @address-selected="addressSelected"></address-search>
    </o-card>
    <o-action-toolbar>
      <div class="d-flex w-100">
        <o-button type="button" variant="outline-primary" @click.prevent="back">{{ $t('core.back') }}</o-button>
        <template-download-button v-if="$route.params.id !== 'new'" :contract-id="$route.params.id" class="ml-2"/>
        <div class="ml-auto">
          <span class="badge badge-danger mr-3" v-if="Math.sign(marketingActivityAdhocAvailable()) === -1">{{ $t('sandoz.budget_exceeded') }}</span>
          <span class="badge badge-danger mr-3" v-else-if="multipleContract">{{ $t('sandoz.duplicate_contract_approval') }}</span>
          <span class="badge badge-danger mr-3" v-else-if="item && item.addresses && isAdHocDraft()">{{ $t('sandoz.adhoc_upload_required') }}</span>
          <o-button
            v-if="isNotDraftContract(item)"
            :loading="saving" type="button" variant="primary"
            @click.prevent="$refs.resetContractModel.show()">{{ $t('sandoz.reset_to_draft') }}
          </o-button>
          <o-button :loading="saving" type="button" variant="primary" :disabled="Math.sign(marketingActivityAdhocAvailable()) === -1 || multipleContract || disableUploadButton"
                    @click.prevent="saveAndStartApproval">{{ $t('sandoz.upload_request_delivery') }}
          </o-button>
          <o-button :loading="saving" type="button" variant="primary" @click.prevent="save">
            {{ item && (item.status == 'Draft') ? $t('sandoz.save_draft') : $t('core.save') }}
          </o-button>
        </div>
      </div>
    </o-action-toolbar>
    <b-modal id="modal-previous-contract" ref="addPreviousContractModel" :ok-only="true"
             :ok-title="$t('core.cancel')" :title="$t('sandoz.select_previous_contract')" size="xl">
      <o-table ref="previousContractList" :enable-delete="false" :enable-edit="false"
               :enable-new="false"
               :only-filterable="true" :shadow="false" title=""
               url="/api/sandoz/contracts?include=master_address_single">
        <template slot="filter">
          <o-filter v-on:filter-updated="(filters) => $refs.previousContractList.setFilters(filters)">
            <o-filter-text :title="$t('sandoz.contract_no')" column="contract_no"></o-filter-text>
            <o-filter-text :title="$t('sandoz.customer_external_id')" column="customer_external_id"></o-filter-text>
            <o-filter-select :items="years" :title="$t('sandoz.contract_year')"
                             column="contract_year"></o-filter-select>
          </o-filter>
        </template>
        <template slot="head">
          <o-table-header column="contract_no">{{ $t('sandoz.contract_no') }}</o-table-header>
          <o-table-header column="customer_external_id">{{ $t('sandoz.customer_external_id') }}</o-table-header>
          <o-table-header column="contract_year">{{ $t('sandoz.contract_year') }}</o-table-header>
          <o-table-header :sortable="false">{{ $t('sandoz.name') }}</o-table-header>
          <o-table-header :sortable="false">{{ $t('sandoz.last_name') }}</o-table-header>
          <o-table-header :sortable="false">{{ $t('sandoz.company_name') }}</o-table-header>
          <o-table-header :sortable="false">{{ $t('sandoz.street') }}</o-table-header>
          <o-table-header :sortable="false">{{ $t('sandoz.zip') }}</o-table-header>
          <o-table-header :sortable="false">{{ $t('sandoz.city') }}</o-table-header>
        </template>
        <template slot="body" slot-scope="previousContractProps">
          <td>{{ previousContractProps.item.contract_no }}</td>
          <td>{{ previousContractProps.item.customer_external_id }}</td>
          <td>{{ previousContractProps.item.contract_year }}</td>
          <td>{{
              previousContractProps.item.master_address_single && previousContractProps.item.master_address_single.data ?
                previousContractProps.item.master_address_single.data.name : ''
            }}
          </td>
          <td>{{
              previousContractProps.item.master_address_single && previousContractProps.item.master_address_single.data ?
                previousContractProps.item.master_address_single.data.last_name : ''
            }}
          </td>
          <td>{{
              previousContractProps.item.master_address_single && previousContractProps.item.master_address_single.data ?
                previousContractProps.item.master_address_single.data.company_name : ''
            }}
          </td>
          <td>{{
              previousContractProps.item.master_address_single && previousContractProps.item.master_address_single.data ?
                previousContractProps.item.master_address_single.data.street : ''
            }}
          </td>
          <td>{{
              previousContractProps.item.master_address_single && previousContractProps.item.master_address_single.data ?
                previousContractProps.item.master_address_single.data.zip : ''
            }}
          </td>
          <td>{{
              previousContractProps.item.master_address_single && previousContractProps.item.master_address_single.data ?
                previousContractProps.item.master_address_single.data.city : ''
            }}
          </td>
        </template>
        <template slot="body-controls" slot-scope="previousContractProps">
          <td class="text-right">
            <div v-if="previousContractProps.item.id === item.id">
              <span class="badge badge-success">Current </span>
            </div>
            <div v-else-if="previousContractProps.item.id === item.previous_contract">
              <span class="badge badge-warning">Previous</span>
            </div>
            <div v-else aria-label="edit controls" class="btn-group btn-group-sm" role="group">
              <b-btn variant="primary" @click="addPreviousContract(previousContractProps.item)">
                <fa icon="arrow-right"/>
              </b-btn>
            </div>
          </td>
        </template>
      </o-table>
    </b-modal>
    <b-modal id="modal-reset-contract" ref="resetContractModel" :title="$t('sandoz.reset_to_draft')">
      {{ $t('sandoz.reset_confirmation_gadget') }}
      <template #modal-footer="{ ok, cancel, hide }">
        <b-button variant="secondary" @click="cancel()">
          {{ $t('core.cancel') }}
        </b-button>
        <b-button variant="primary" @click="resetToDraft()">
          {{ $t('core.ok') }}
        </b-button>
      </template>
    </b-modal>
    <b-modal id="modal-duplicate-contract" ref="duplicateContractModel" :title="$t('sandoz.duplicate_contract')">
      {{ $t('sandoz.duplicate_contract_error') }}
      <template #modal-footer="{ ok, cancel, hide }">
        <b-button variant="secondary" @click="showDuplicateContract">
          {{ $t('sandoz.show_contract') }}
        </b-button>
        <b-button variant="primary" @click="cancel()">
          {{ $t('core.ok') }}
        </b-button>
      </template>
    </b-modal>
    <b-modal id="modal-item" ref="itemModel" :ok-only="true" :ok-title="$t('core.cancel')" :title="$t('sandoz.items')" size="xl">
      <div class="table-responsive">
        <table class="table item-table">
          <thead>
          <th>{{$t('sandoz.item')}}</th>
          <th>{{$t('sandoz.item_price')}}</th>
          <th></th>
          </thead>
          <tbody>
          <template v-for="(result, resultIndex) in itemList">
            <tr :class="{'d-none': result.exist_value === 'yes' || result.item_visibility === 'item'}">
              <td>
                {{ result.product ? result.product.name : result.product_name }}
              </td>
              <td>
                {{ result.item_price }}
              </td>
              <td>
                <b-btn size="sm" @click="selectItem(result)">
                  <fa icon="arrow-right"/>
                </b-btn>
              </td>
            </tr>
            <template v-for="(sub, subIndex) in result.children">
              <tr :class="{'d-none': sub.exist_value === 'yes' || sub.item_visibility === 'item'}">
                <td>
                  {{ sub.product ? sub.product.name : sub.product_name }}
                </td>
                <td>
                  {{ sub.item_price }}
                </td>
                <td>
                  <b-btn size="sm" @click="selectItem(sub)">
                    <fa icon="arrow-right"/>
                  </b-btn>
                </td>
              </tr>
              <template v-for="(child, childIndex) in sub.children">
                <tr :class="{'d-none': child.exist_value === 'yes' || child.item_visibility === 'item'}">
                  <td>
                    {{ child.product ? child.product.name : child.product_name }}
                  </td>
                  <td>
                    {{ child.item_price }}
                  </td>
                  <td>
                    <b-btn size="sm" @click="selectItem(child)">
                      <fa icon="arrow-right"/>
                    </b-btn>
                  </td>
                </tr>
              </template>
            </template>
          </template>
          </tbody>
        </table>
      </div>
    </b-modal>
  </form>
</template>

<script>
import {mapGetters} from 'vuex'
import axios from 'axios'
import {contractYears} from '../../../utils/contractYear'
import AddressSearch from '../partials/AddressSearch.vue'
import OValueSelectControl from '../../../components/OrticValueSelectControl.vue'
import moment from 'moment'
import TemplateDownloadButton from '../partials/TemplateDownloadButton.vue'

export default {
  components: {
    OValueSelectControl,
    AddressSearch,
    contractYears,
    TemplateDownloadButton
  },
  data: () => ({
    contractTypes: [],
    years: [],
    item: null,
    customerSizes: [],
    watchers: [],
    saving: false,
    addressIndex: null,
    toggleItems: false,
    listItem: [],
    selectedItems: [],
    searchItem: null,
    months: [],
    loaded: false,
    currentUser: null,
    watcherWorking: false,
    addItemsToAllAddress: false,
    changeExternalID: false,
    downloadPDF: false,
    itemOld: null,
    languages: [],
    accordionItems: [],
    showContract: null,
    wordfile: null,
    investAccordion: false,
    copyMasterProductToChild: [],
    determErrorID: [],
    addItemsToAddressFlag: false,
    addItemsToAddressFlagIndex: null,
    wholesalerArray: [],
    titleItems: [],
    disableToDates: {
      to: null
    },
    plan_turnover_outside_range: null,
    plan_turnover_expectation_outside_range: null,
    plan_invest_outside_range: null,
    plan_discount_outside_range: null,
    displayPlanDeviationSkipApproval: false,
    buyingGroupLabel: 'buying_group',
    planData: null,
    activeTab: 0,
    newFileCounter: 0,
    plan_turnover_expectation_condition: null,
    plan_invest_condition: null,
    plan_discount_condition: null,
    heimCustomerSizes: [],
    marketing_activities_percentage: null,
    pdfLoading: false,
    vendorFormLinks: {
      DE: 'https://sandozcollab.sharepoint.com/:w:/r/sites/sandoz-schweiz-intranet/teamsites/Freigegebene%20Dokumente/Marketing/ZZ_NICHT%20LOESCHEN%20ODER%20VERSCHIEBEN/Formular%20f%C3%BCr%20Vendorer%C3%B6ffnung_DE_2024.doc?d=w429524bc2ddd45dcaa24f693c1aaae5b&csf=1&web=1&e=508gVl&xsdata=MDV8MDJ8YmVhdC5zdGVpbmVnZ2VyQHNhbmRvei5jb218NzA0NDBhMWNlMjJkNGRjMmQ5ZDcwOGRlMTFmZjRhN2V8MTVlYWUyY2IxYzk0NGQxZjgwNGZjYjBjMzQ3ZGJkYWR8MHwwfDYzODk2Nzk4NTQ4NTg1NDkxMXxVbmtub3dufFRXRnBiR1pzYjNkOGV5SkZiWEIwZVUxaGNHa2lPblJ5ZFdVc0lsWWlPaUl3TGpBdU1EQXdNQ0lzSWxBaU9pSlhhVzR6TWlJc0lrRk9Jam9pVFdGcGJDSXNJbGRVSWpveWZRPT18MHx8fA%3d%3d&sdata=ZWloUzZNUGk4NWgrRzRvKzFsQmhIeWI3T01rTGpTU1V3M3pEYWI5dGRNQT0%3d',
      FR: 'https://sandozcollab.sharepoint.com/:w:/r/sites/sandoz-schweiz-intranet/teamsites/Freigegebene%20Dokumente/Marketing/ZZ_NICHT%20LOESCHEN%20ODER%20VERSCHIEBEN/Formular%20f%C3%BCr%20Vendorer%C3%B6ffnung_FR_2024.doc?d=w49f246b7c89848be897188826334fc2b&csf=1&web=1&e=pID1ir&xsdata=MDV8MDJ8YmVhdC5zdGVpbmVnZ2VyQHNhbmRvei5jb218NzA0NDBhMWNlMjJkNGRjMmQ5ZDcwOGRlMTFmZjRhN2V8MTVlYWUyY2IxYzk0NGQxZjgwNGZjYjBjMzQ3ZGJkYWR8MHwwfDYzODk2Nzk4NTQ4NTgwMDY5MHxVbmtub3dufFRXRnBiR1pzYjNkOGV5SkZiWEIwZVUxaGNHa2lPblJ5ZFdVc0lsWWlPaUl3TGpBdU1EQXdNQ0lzSWxBaU9pSlhhVzR6TWlJc0lrRk9Jam9pVFdGcGJDSXNJbGRVSWpveWZRPT18MHx8fA%3d%3d&sdata=TFNEOTgyN25YM3ppR2xlVXRxRGpFR0dna3F2YURkV0JRYW9uaktaZFNPND0%3d',
      IT: 'https://sandozcollab.sharepoint.com/:w:/r/sites/sandoz-schweiz-intranet/teamsites/Freigegebene%20Dokumente/Marketing/ZZ_NICHT%20LOESCHEN%20ODER%20VERSCHIEBEN/Formular%20f%C3%BCr%20Vendorer%C3%B6ffnung_IT_2024.doc?d=w6a072b20b8504e1c9ff128710757020e&csf=1&web=1&e=umGkd2&xsdata=MDV8MDJ8YmVhdC5zdGVpbmVnZ2VyQHNhbmRvei5jb218NzA0NDBhMWNlMjJkNGRjMmQ5ZDcwOGRlMTFmZjRhN2V8MTVlYWUyY2IxYzk0NGQxZjgwNGZjYjBjMzQ3ZGJkYWR8MHwwfDYzODk2Nzk4NTQ4NTgzMTc0MnxVbmtub3dufFRXRnBiR1pzYjNkOGV5SkZiWEIwZVUxaGNHa2lPblJ5ZFdVc0lsWWlPaUl3TGpBdU1EQXdNQ0lzSWxBaU9pSlhhVzR6TWlJc0lrRk9Jam9pVFdGcGJDSXNJbGRVSWpveWZRPT18MHx8fA%3d%3d&sdata=b3pRT1dTRXlXcjkwaE5Lbm1tNjFTU0g4SERKd2ZwUzh3bU9RcjhrOGUwWT0%3d'
    },
    fromDateErrorID: [],
    isCommentError: false,
    isHCPSet: false,
    itemList: [],
    marketingActivitiesStandard: 0,
    marketingActivitiesAdhoc: 0,
    isRequestDelivery: false,
    pictures: [],
    contractTypesTf: [],
    multipleContract: false,
    quarterDates:[],
    subAddressList: {
      input: '',
      externalIDs: []
    },
    disableUploadButton: false
  }),
  mounted() {
    this.loadData()    
  },
  computed: {
    ...mapGetters({
      user: 'auth/user'
    }),
    readonly() {
      return this.item && this.item.status !== 'Draft' && this.item.status !== 'Feedback'
    },
    turnoverExpectionPercentageBaseline() {
      if (!this.item.turnover_expectation || this.getPlanDataTurnoverActual() === null || this.getPlanDataTurnoverActual() === 0) {
        return null
      }
      return Math.round((this.item.turnover_expectation / this.getPlanDataTurnoverActual() - 1) * 10000) / 100 + '%'
    },
    investMaxPercentage() {
      if (!this.item.invest_max_percentage) {
        return null
      }
      return parseFloat(this.item.invest_max_percentage * 100).toFixed(2) + '%'
    }
  },
  watch: {
    'item.contract_start': function (newVal) {
      let startDate = moment(newVal);
      this.disableToDates.to = new Date(startDate.format('YYYY'), startDate.month(), startDate.format('D'))
      this.setContractDateToItems(newVal)
      if (this.item && (this.item.status === 'Draft' || this.item.status === 'Feedback')) {
        this.loadplanData()
      }

    },
    'item.contract_expiration': function (newVal) {
      this.setContractDateToItems(newVal)
      if (this.item && (this.item.status === 'Draft' || this.item.status === 'Feedback')) {
        this.loadplanData()
      }
    },
    saving: function (newVal, oldVal) {
      const self = this
      if (!newVal) {
        setTimeout(function () {
          self.pdfLoading = newVal
        }, 1000)
      } else {
        self.pdfLoading = newVal
      }
    }
  },
  created() {
    this.years = contractYears()
    this.contractTypes = [
      {value: 'SD_GADGET', text: this.$i18n.t('sandoz.sd_gadget')},
      /*{value: 'ONCO_GADGET', text: this.$i18n.t('sandoz.onco_gadget')},*/
      {value: 'IMMUNO_GADGET', text: this.$i18n.t('sandoz.immuno_gadget')},
      {value: 'KAM_SD_GADGET', text: this.$i18n.t('sandoz.kam_sd_gadget')},
      {value: 'HIGHSPEC_GADGET', text: this.$i18n.t('sandoz.highspec_gadget')},
      {value: 'APO_GADGET', text: this.$i18n.t('sandoz.apo_gadget')},
      {value: 'KAM_APO_GADGET', text: this.$i18n.t('sandoz.kam_apo_gadget')},
    ]

    this.contractTypesTf = [
      {value: 'SD_GADGET', text: this.$i18n.t('sandoz.sd_gadget')},
      {value: 'CNS_GADGET', text: this.$i18n.t('sandoz.cns_gadget')},
      /*{value: 'ONCO_GADGET', text: this.$i18n.t('sandoz.onco_gadget')},*/
      {value: 'IMMUNO_GADGET', text: this.$i18n.t('sandoz.immuno_gadget')},
      {value: 'KAM_SD_GADGET', text: this.$i18n.t('sandoz.kam_sd_gadget')},
      {value: 'APO_GADGET', text: this.$i18n.t('sandoz.apo_gadget')},
      {value: 'KAM_APO_GADGET', text: this.$i18n.t('sandoz.kam_apo_gadget')},
    ]

    this.months = [
      {value: '01', text: this.$i18n.t('core.january_short')},
      {value: '02', text: this.$i18n.t('core.february_short')},
      {value: '03', text: this.$i18n.t('core.march_short')},
      {value: '04', text: this.$i18n.t('core.april_short')},
      {value: '05', text: this.$i18n.t('core.may_short')},
      {value: '06', text: this.$i18n.t('core.june_short')},
      {value: '07', text: this.$i18n.t('core.july_short')},
      {value: '08', text: this.$i18n.t('core.august_short')},
      {value: '09', text: this.$i18n.t('core.september_short')},
      {value: '10', text: this.$i18n.t('core.october_short')},
      {value: '11', text: this.$i18n.t('core.november_short')},
      {value: '12', text: this.$i18n.t('core.december_short')}
    ]

    this.languages = [
      {value: 'DE', text: 'DE'},
      {value: 'FR', text: 'FR'},
      {value: 'IT', text: 'IT'}
    ]
  },
  methods: {
    loadData() {
      this.saving = true
      var url = `/api/sandoz/gadget/contracts/${this.$route.params.id}?include=word_files.user,pdfs.user,previous`
      this.url = url
      axios
        .get(url)
        .then((response) => {
          var item = response
          if (this.dataKey) {
            item = response[this.dataKey]
          }
          this.item = item.data

          // set default user
          if (!this.item.user_id) {
            this.item.user_id = this.user.id
          }

          this.setTitleItems()
          this.loadplanData()
          this.getAddressItemData()
          this.quarterDates = this.getQuarterStartDates(this.item.contract_year);
        })
    },
    getAddressItemData() {
      var url = `/api/sandoz/gadget/contracts/detail/${this.$route.params.id}`
      axios
        .get(url)
        .then((response) => {
          var item = response
          this.item.addresses = item.data.addresses
          var dbItem = Object.assign({}, this.item)
          this.$nextTick(() => {
            this.loaded = true
            this.addItemsToAddresses(false)
            this.setDefaultPrice()
            this.setContractDateToItems()
            this.setQuantityChildParent(1)
            this.setQuantityToChildSpecialLoad()
            this.enableWatchers()
            this.setSelectedItemPrice()
            this.setCalculatedInvest()
            this.isAdHocDraft()
            this.multipleContractCheck()
            this.$nextTick(() => {
              this.itemOld = {...this.item}
              this.itemOld.marketing_activities = dbItem.marketing_activities
              this.saving = false
            })
          })
        })
    },
    enableWatchers() {
      this.watchers.push(this.$watch('item.type', (newVal) => {
        this.setContractNo()
      }))
      this.watchers.push(this.$watch('item.customer_external_id', (newVal) => {
        this.changeExternalID = true
        this.setContractNo()
        this.setPreviousContract();
        this.multipleContractCheck()
      }))
      this.watchers.push(this.$watch('item.contract_year', (newVal) => {
        this.setContractNo()
        this.setPreviousContract()
        this.addItemsToAddresses()
        this.changeContractDuration()
        this.loadplanData()
        this.multipleContractCheck()
        this.quarterDates = this.getQuarterStartDates(newVal);
      }))
      this.watchers.push(this.$watch('item.type', (newVal) => {
        this.setPreviousContract()
        this.loadplanData()
      }))
      this.watchers.push(this.$watch('item.type', (newVal) => {
        this.addItemsToAddresses()
      }))
      this.watchers.push(this.$watch('item.type', (newVal) => {
        this.setTurnoverInvest()
      }))
      this.watchers.push(this.$watch('item.type', (newVal) => {
        this.setTurnoverExpectation()
      }))

      this.watchers.push(this.$watch('item.turnover', (newVal) => {
        if (!this.item.turnover_expectation) {
          return
        }
        this.item.growth_forecast = this.item.turnover_expectation - newVal
        this.setTurnoverInvest()
      }))
      this.watchers.push(this.$watch('item.turnover_expectation', (newVal) => {
        if (!this.item.turnover) {
          return
        }
        this.setWithoutWatcher('marketing_activities_percentage', this.item.marketing_activities_maximum / newVal)
        this.item.growth_forecast = newVal - this.item.turnover
        this.setTurnoverInvest()
      }))
      this.watchers.push(this.$watch('item.growth_forecast', (newVal) => {
        this.setTurnoverExpectation()
      }))
      this.watchers.push(this.$watch('item.marketing_activities_percentage', (newVal) => {
        this.setWithoutWatcher('marketing_activities_maximum', newVal * this.item.turnover_expectation)
      }))
      this.watchers.push(this.$watch('item.marketing_activities_maximum', (newVal) => {
        this.setWithoutWatcher('marketing_activities_percentage', newVal / this.item.turnover_expectation)
      }))
      this.watchers.push(this.$watch('item.language', (newVal) => {
        this.addItemsToAddresses()
        this.setTitleItems()
      }))

      this.watchers.push(this.$watch('planData', (newVal) => {
        this.setTurnoverInvest()
        this.setTurnoverExpectation()
      }))
    },
    setCalculatedInvest() {
      var _self = this
      var total = 0
      _self.$nextTick(function () {
        if (_self.item.addresses) {
          _self.isHCPSet = false
          _self.item.addresses.forEach(function (address) {
            if (address.address_type === 'master') {
              total = total + parseInt(address.number_of_hcps)
              _self.isHCPSet = true
            }
          })
        }

        this.item.invest_max = total * 300
        this.item.marketing_activities_maximum = this.item.invest_max
        if(this.item.turnover_expectation && this.item.turnover_expectation != 0.00 && this.item.invest_max && this.item.invest_max !== 0) {
          this.item.invest_max_percentage = this.item.invest_max / parseFloat(this.item.turnover_expectation)
        }
        this.$forceUpdate()
      })

    },
    disableWatchers() {

    },
    saveAndStartApproval() {
      var _self = this
      var planDateYearDifferent = false
      if (_self.item.addresses) {
        _self.item.addresses.forEach(function (address) {
          if (address.address_type !== 'delivery') {
            return false
          }

            if (address.adhoc_items.length) {
              address.adhoc_items.forEach(function (itm) {
                if (itm.delivery && Object.keys(itm.delivery).length && (itm.item_visibility === 'both' || itm.item_visibility === 'adhoc_item')) {
                  Object.keys(itm.delivery).forEach(function (p) {
                    if (p !== 'yearly' || (itm.delivery[p] && itm.delivery[p].quantity <= 0)) {
                      return false
                    }

                    if(_self.item.contract_year != moment(new Date()).format("YYYY")) {
                      planDateYearDifferent = true
                    }

                    if (planDateYearDifferent || (itm.delivery[p] && itm.delivery[p].planned_delivery)) {
                      return false
                    }

                    if((itm.product && itm.product.product_master && !itm.product.product_master.adhoc_delivery_per_quarter)) {
                      itm.delivery[p].planned_delivery = moment(new Date()).format("YYYY-MM-DD") + ' 00:00:01'
                    }
                    itm.delivery[p].is_changed = true
                  })
                }
              })
            }
        })
      }

      if(planDateYearDifferent === true) {
        _self.$notify({
          title: _self.$i18n.t('core.validation_error'),
          text: _self.$i18n.t('core.validation_error_text', { message: _self.$i18n.t('sandoz.plan_date_mismatch_with_year') }),
          type: 'error'
        })
        return
      }
      this.item.status = 'Committed'
      this.isRequestDelivery = true

      this.disableUploadButton = true
      this.save()
    },
    resetToDraft() {
      this.item.status = 'Draft'

      this.item.approval_date_1 = null
      this.item.approval_person_1 = null

      this.item.approval_date_2 = null
      this.item.approval_person_2 = null

      this.item.approval_date_3 = null
      this.item.approval_person_3 = null

      this.item.approval_date_4 = null
      this.item.approval_person_4 = null

      this.item.approval_date_5 = null
      this.item.approval_person_5 = null

      this.item.approval_date_6 = null
      this.item.approval_person_6 = null

      this.item.next_approver = null

      if (this.item.status === 'Signed') {
        this.item.contract_version = (!this.item.contract_version || this.item.contract_version == 1) ? 2 : this.item.contract_version + 1
      }
      this.isRequestDelivery = false
      this.save()
      this.$refs.resetContractModel.hide()
    },
    save() {
      var url = `/api/sandoz/gadget/contracts/${this.$route.params.id}?include=word_files.user,previous`
      // var url = this.url
      var route = this.$route

      // this happens if we create a new data record and update it right away without navigating way. We'll still have
      // new in our url, but we don't want to create a new record, we want to update the record we just created.
      // @TODO we should do this in a more elegant way that doesn't require search & replace
      if (url.indexOf('/new') > 0 && 'id' in this.item) {
        url = url.replace('/new', '/' + this.item.id)
      }

      var root = this.$root
      var self = this

      if(self.item.type ===  null) {
        self.$notify({
          title: self.$i18n.t('core.validation_error'),
          text: self.$i18n.t('core.validation_error_text', { message: self.$i18n.t('sandoz.type_required') }),
          type: 'error'
        })
        return
      }

      if(self.item.customer_external_id ===  null) {
        self.$notify({
          title: self.$i18n.t('core.validation_error'),
          text: self.$i18n.t('core.validation_error_text', { message: self.$i18n.t('sandoz.external_id_required') }),
          type: 'error'
        })
        return
      }

      if(self.item.contract_year ===  null) {
        self.$notify({
          title: self.$i18n.t('core.validation_error'),
          text: self.$i18n.t('core.validation_error_text', { message: self.$i18n.t('sandoz.contract_year_required') }),
          type: 'error'
        })
        return
      }

      if(self.item.language ===  null) {
        self.$notify({
          title: self.$i18n.t('core.validation_error'),
          text: self.$i18n.t('core.validation_error_text', { message: self.$i18n.t('sandoz.language_required') }),
          type: 'error'
        })
        return
      }

      if(self.item.contract_year !== moment(self.item.contract_start).year()) {
        self.$notify({
          title: self.$i18n.t('core.validation_error'),
          text: self.$i18n.t('core.validation_error_text', { message: self.$i18n.t('sandoz.contract_start_mismatch_with_year') }),
          type: 'error'
        })
        return
      }

      var indeterminantEror = self.checkIndeterminantCheckbox();
      if (indeterminantEror) {
        self.$notify({
          title: self.$i18n.t('core.validation_error'),
          text: self.$i18n.t('core.validation_error_text', {message: self.$i18n.t('sandoz.indeterminat_error')}),
          type: 'error'
        })
        return
      }

      if(self.item.new_customer === null && (self.item.previous_contract === undefined || self.item.previous_contract === null)) {
        self.$notify({
          title: self.$i18n.t('core.validation_error'),
          text: self.$i18n.t('core.validation_error_text', { message: self.$i18n.t('sandoz.previous_contract_required') }),
          type: 'error'
        })
        return
      }

      this.disableWatchers()
      this.saving = true
      this.showContract = null

      axios
        .post(url, this.item)
        .then((response) => {
          let savedItem = response.data
          // this.item = response.data

          // assign our new id to the route params in case someone wants to work with it
          if ('id' in response.data) {
            if (this.$route.params.id === 'new') {
              this.item.id = response.data.id
            }
            route.params.id = response.data.id
          }

          this.$notify({
            title: this.$i18n.t('core.saved'),
            text: this.$i18n.t('core.saved_text')
          })

          // remove all error states
          var elements = document.querySelectorAll('.has-error')
          elements.forEach((element) => {
            element.classList.remove('has-error')
          })
          this.fromDateErrorID = []
          this.isCommentError = false

          // clear all errors
          root.errors = {}
          if (this.downloadPDF) {
            this.pdfContract()
            this.$nextTick(function () {
              this.itemOld = {...this.item}
              this.downloadPDF = false
            })
          } else {
            this.loaded = true
            this.getAddressItemData()
          }
        })
        .catch((error) => {
          // stop loading indicator
          self.saving = false

          if (error.response.status === 422 && 'data' in error.response && 'message' in error.response.data) {
            this.$notify({
              title: this.$i18n.t('core.validation_error'),
              text: this.$i18n.t('core.validation_error_text', {message: error.response.data.message}),
              type: 'error'
            })
            if ('data' in error.response && 'errors' in error.response.data) {
              root.errors = error.response.data.errors
            }
          } else {
            if (error.response.data && 'contract_error' in error.response.data && error.response.data.contract_error === 'contract_already_exists') {
              this.showContract = error.response.data.contract
              this.$refs.duplicateContractModel.show()
            } else {
              this.$notify({
                title: this.$i18n.t('core.save_error'),
                text: this.$i18n.t('core.save_error_text', {url: this.url}),
                type: 'error'
              })
            }
          }

          if (self.isRequestDelivery) {
            if (self.item.addresses) {
              self.item.addresses.forEach(function (address) {
                if (address.address_type !== 'delivery') {
                  return false
                }

                if (address.adhoc_items.length) {
                  address.adhoc_items.forEach(function (itm) {
                    if (itm.delivery && Object.keys(itm.delivery).length && (itm.item_visibility === 'both' || itm.item_visibility === 'adhoc_item')) {
                      Object.keys(itm.delivery).forEach(function (p) {
                        if (p === 'yearly' && (itm.delivery[p] && !itm.delivery[p].is_changed)) {
                          return false
                        }

                        itm.delivery[p].planned_delivery = null
                        itm.delivery[p].is_changed = false
                      })
                    }
                  })
                }
              })
            }
            self.item.status = 'Draft'
          }
        })
    },
    back() {
      this.$router.back()
    },
    addAddress() {
      this.addressMode = 'delivery'
      this.$refs.addressSearch.showAddressSearchModal(this)
    },
    setContractNo() {
      if (!this.item.type || !this.item.contract_year || !this.item.customer_external_id) {
        return
      }

      this.item.contract_no = `${this.item.type}-${this.item.contract_year - 2000}-${this.item.customer_external_id}`
    },
    setCurrentUser(user) {
      if (!user) {
        return
      }
      this.currentUser = user
    },
    setMasterAddress() {
      this.addressMode = 'master'
      this.$refs.addressSearch.showAddressSearchModal(this)
    },
    setTurnoverInvest() {
      var url = `/api/sandoz/sales_lines?filter[sales_line]=${this.item.type}`
      axios
        .get(url)
        .then((response) => {
          if (response.data.data && '0' in response.data.data) {

            this.item.sales_line = response.data.data[0]
            var maximumInvest = response.data.data[0].maximum_invest
            if (maximumInvest) {
              this.item.invest_turnover = parseFloat(this.getPlanDataTurnoverActual() * maximumInvest).toFixed(2)
              this.item.invest_turnover_percentage = maximumInvest
            } else {
              this.item.invest_turnover = null
              this.item.invest_turnover_percentage = null
            }
            this.$nextTick(() => {
              this.calculatePlanTurnOver()
              this.calculatePlanTurnOverExpectation()
              this.calculatePlanTargetInvest()
              this.calculatePlanTargetDiscount()
            })
          }
        })
    },
    setTurnoverExpectation() {
      var url = `/api/sandoz/sales_lines?filter[sales_line]=${this.item.type}`
      axios
        .get(url)
        .then((response) => {
          if (response.data.data && '0' in response.data.data) {
            this.item.sales_line = response.data.data[0]
            let maximumInvestExpectation = response.data.data[0].maximum_invest_expectation
            if (maximumInvestExpectation) {
              this.item.invest_growth = parseFloat(maximumInvestExpectation).toFixed(2)
              this.item.invest_turnover_forecast = parseFloat(this.item.growth_forecast * maximumInvestExpectation).toFixed(2)
            } else {
              this.item.invest_growth = null
              this.item.invest_turnover_forecast = null
            }

            this.$nextTick(() => {
              this.calculatePlanTurnOver()
              this.calculatePlanTurnOverExpectation()
              this.calculatePlanTargetInvest()
              this.calculatePlanTargetDiscount()
            })
          }
        })
    },
    setWithoutWatcher(propertyName, value) {
      if (this.watcherWorking || !this.loaded) {
        return
      }
      this.watcherWorking = true
      this.item[propertyName] = value
      this.$nextTick(() => {
        this.watcherWorking = false
      })
    },
    addressSelected(addressEvent) {
      let address = addressEvent.address
      let multipleContractsPerPractice = addressEvent.multipleContractsPerPractice
      let owningComponent = addressEvent.owningComponent
      let owningComponentData = owningComponent.$data

      // set external id
      let externalId = multipleContractsPerPractice ? address.external_id : address.org_external_id

      switch (this.addressMode) {
        case 'master':
          owningComponentData.item.customer_external_id = externalId

          // set bank data
          // owningComponentData.item.vat = !!address.org_vat ? 'x': null
          owningComponentData.item.vat_number = address.org_vat
          owningComponentData.item.bank_name = address.org_bank_name
          owningComponentData.item.bank_address = address.org_bank_address
          owningComponentData.item.accountholder_name = address.org_bank_account
          owningComponentData.item.accountholder_address = address.org_bank_account_address
          owningComponentData.item.iban_no = address.org_iban

          this.item.language = address.language
          this.loadplanData()
          // set buying group
          if (address.buying_group && Object.keys(address.buying_group).length > 0) {
            this.item.buying_group_code_when_uploaded = address.buying_group.buying_group_code
            this.item.customer_group = address.buying_group.buying_group
          } else {
            this.item.customer_group = null
            this.item.buying_group_code_when_uploaded = null
          }

          this.setTurnoverInvest()
          let masterAddressData = {
            del_address: 1,
            address_type: 'master',
            company_name: address.org_full_name,
            street: address.org_street,
            zip: address.org_zip_code,
            city: address.org_city,
            customer_external_id: externalId,
            customer_external_id_hcp: address.external_id,
            customer_size: address.org_pharmacy_classification,
            default_customer_size: address.org_pharmacy_classification
          }

          let firstAddress = owningComponentData.item.addresses.length == 0

          if (owningComponentData.item.addresses.length > 0) {
            owningComponentData.item.addresses[0] = masterAddressData
          } else {
            owningComponentData.item.addresses.push(masterAddressData)
          }

          // always add a delivery address as well
          let deliveryAddress = {
            del_address: owningComponentData.item.addresses.length + 1,
            address_type: 'delivery',
            company_name: address.org_full_name,
            street: address.org_street,
            zip: address.org_zip_code,
            city: address.org_city,
            customer_external_id: externalId,
            customer_external_id_hcp: address.external_id,
            customer_size: address.org_pharmacy_classification,
            default_customer_size: address.org_pharmacy_classification,
            items: [],
            adhoc_items: []
          }
          if (firstAddress) {
            owningComponentData.item.addresses.push(deliveryAddress)
            this.addItemsToAddresses(false)
          }

          break
        case 'delivery':
          owningComponentData.item.addresses.push({
            del_address: owningComponentData.item.addresses.length + 1,
            address_type: 'delivery',
            company_name: address.org_full_name,
            street: address.org_street,
            zip: address.org_zip_code,
            city: address.org_city,
            customer_external_id: externalId,
            customer_external_id_hcp: address.external_id,
            customer_size: address.org_pharmacy_classification,
            default_customer_size: address.org_pharmacy_classification,
            items: [],
            adhoc_items: []
          })
          this.addItemsToAddresses(false)
          this.setContractDateToItems()
          break
      }
    },
    isReadonly(line, q, child = false) {
      let field = null
      let qStartMonth = null
      let qEndMonth = null
      let assinable = null
      switch (q) {
        case 'q1':
          field = 'user_date_q1_input'
          qStartMonth = 1
          qEndMonth = 3
          assinable = 'q1_assignable'
          break
        case 'q2':
          field = 'user_date_q2_input'
          qStartMonth = 4
          qEndMonth = 6
          assinable = 'q2_assignable'
          break
        case 'q3':
          field = 'user_date_q3_input'
          qStartMonth = 7
          qEndMonth = 9
          assinable = 'q3_assignable'
          break
        case 'q4':
          field = 'user_date_q4_input'
          qStartMonth = 10
          qEndMonth = 12
          assinable = 'q4_assignable'
          break
        case 'yearly':
          field = 'user_date_yearly_input'
          break
      }

      if (q === 'yearly') {
        return !(!!line[field] && (line.delivery && line.delivery[q] && !line.delivery[q].is_deleted ? !line.delivery[q].is_delivery_executed : true))
      }

      let validFromMonth = null
      if (line.valid_from_month) {
        validFromMonth = line.valid_from_month
      }
      let validToMonth = null
      if (line.valid_to_month) {
        validToMonth = line.valid_to_month
      }

      if (line.delivery && Object.keys(line.delivery).length && validFromMonth && validToMonth && line.delivery[q] && line.delivery[q].quantity > 0 && ((validFromMonth > qEndMonth || validToMonth < qStartMonth))) {
        line.delivery[q].quantity = null
      }

      return !(!!line[field] && (!validFromMonth || validFromMonth <= qEndMonth) && (validToMonth && validToMonth >= qStartMonth) &&
        (line.delivery && line.delivery[q] && !line.delivery[q].is_deleted ? !line.delivery[q].is_delivery_executed : true))
    },
    setDateToChildren(line, i, type = 'from') {
      const self = this
      self.$nextTick(function () {
        if (!!line.allow_date_to_set_children) {
          if (line.children && Object.keys(line.children).length) {
            line.children.forEach(function (subLine) {
              if (type === 'from') {
                subLine.valid_from = line.valid_from
                subLine.valid_from_month = line.valid_from_month
                subLine.valid_from_year = line.valid_from_year
              } else {
                subLine.valid_to = line.valid_to
                subLine.valid_to_month = line.valid_to_month
                subLine.valid_to_year = line.valid_to_year
              }

              self.setPrice(subLine, i)

              if (!!subLine.allow_date_to_set_children) {
                if (subLine.children && Object.keys(subLine.children).length) {
                  subLine.children.forEach(function (childLine) {
                    if (type === 'from') {
                      childLine.valid_from = subLine.valid_from
                      childLine.valid_from_month = subLine.valid_from_month
                      childLine.valid_from_year = subLine.valid_from_year
                    } else {
                      childLine.valid_to = subLine.valid_to
                      childLine.valid_to_month = subLine.valid_to_month
                      childLine.valid_to_year = subLine.valid_to_year
                    }

                    self.setPrice(childLine, i)
                  })
                }
              }
            })
          }
        }
        self.setQuantityToChildSpecialLoad()
        self.setQuantityChildParent()
        self.setPrice(line, i)
      })
    },
    setDateChanged(line, type) {
      let self = this
      this.$nextTick(function () {
        if (!!line.allow_date_to_set_children) {
          this.setHighLighter(line)
          if (line.children && Object.keys(line.children).length) {
            line.children.forEach(function (subLine) {
              self.setHighLighter(subLine)
              if (type === 'from') {
                subLine.valid_from_changed = true
              } else {
                subLine.valid_to_changed = true
              }

              if (!!subLine.allow_date_to_set_children) {
                if (subLine.children && Object.keys(subLine.children).length) {
                  subLine.children.forEach(function (childLine) {
                    self.setHighLighter(childLine)
                    if (type === 'from') {
                      childLine.valid_from_changed = true
                    } else {
                      childLine.valid_to_changed = true
                    }
                  })
                }
              }
            })
          }
        }

        if (type === 'from') {
          line.valid_from_changed = true
        } else {
          line.valid_to_changed = true
        }
      })
    },
    setQuantityToParent(line, subLine, q, i) {
      const self = this
      var parentQuantityQuarter = 0
      let syncquatersWithChidren = []

      this.$nextTick(function () {
        self.setPrice(subLine, i, q)
        line['sync_quarter_' + q] = false
        if (line.children && Object.keys(line.children).length) {
          line.children.forEach(function (forSubLine, subLineIndex) {

            if (forSubLine.sync_quater_with_children) {
              var subLineQuantity = forSubLine.delivery && forSubLine.delivery[q] ? forSubLine.delivery[q].quantity : null
              forSubLine['sync_quarter_' + q] = false

              if (subLineQuantity !== null && syncquatersWithChidren.includes(q)) {
                forSubLine['sync_quarter_' + q] = true
                line['sync_quarter_' + q] = true
              }

              if (subLineQuantity !== null && !syncquatersWithChidren.includes(q)) {
                syncquatersWithChidren.push(q)
              }
            }

            if (!!forSubLine.write_qty_from_child_to_parent) {
              if (line.delivery) {
                var quantity = forSubLine.delivery ? parseInt(forSubLine.delivery[q].quantity) : 0
                if (quantity > 0) {
                  parentQuantityQuarter += quantity
                }
              }
            }
          })
        }

        if (line.digitial_screen_category === true) {
          parentQuantityQuarter = parentQuantityQuarter === 0 ? null : parentQuantityQuarter
          line.delivery[q].quantity = parentQuantityQuarter

          // Set orange background to digitial_screen_category products
          let quaters = ['price', 'yearly', 'q1', 'q2', 'q3', 'q4'];
          var quaterQuantity = false
          quaters.forEach(function (q, qindex) {
            if (q !== 'price' && line.delivery[q] && line.delivery[q].quantity > 0) {
              quaterQuantity = true
            }
          })
          quaters.forEach(function (q1, qindex) {
            var quaterStartEndMonthData = self.getQuaterStartEndMonth(q1);
            if (q1 !== 'price' && (quaterStartEndMonthData.qStartMonth !== null && quaterStartEndMonthData.qEndMonth !== null && line.valid_from_month <= quaterStartEndMonthData.qEndMonth && line.valid_to_month >= quaterStartEndMonthData.qStartMonth) && quaterQuantity === true && line.delivery[q1] && (line.delivery[q1].quantity === null || line.delivery[q1].quantity === 0)) {
              line.delivery[q1].error = true
            } else {
              if (line.delivery[q1]) {
                line.delivery[q1].error = false
              }
            }
            self.setPrice(line, i, q1)
          })
        }
      })
    },
    setDefaultPrice() {
      var _self = this
      _self.$nextTick(function () {
        if (_self.item.addresses) {
          _self.item.addresses.forEach(function (address) {
            if (address.address_type !== 'delivery') {
              return false
            }

            if (address.items.length) {
              address.items.forEach(function (item) {
                //item.price = item.loaded_price ? Math.round(item.loaded_price) : null
                item.price = item.loaded_price ? item.loaded_price : null
                if (item.children && Object.keys(item.children).length) {
                  item.children.forEach(function (subItem) {
                    //subItem.price = subItem.loaded_price ? Math.round(subItem.loaded_price) : null
                    subItem.price = subItem.loaded_price ? subItem.loaded_price : null

                    if (subItem.children && Object.keys(subItem.children).length) {
                      subItem.children.forEach(function (childItem) {
                        childItem.price = childItem.loaded_price ? childItem.loaded_price : null
                        //childItem.price = childItem.loaded_price ? Math.round(childItem.loaded_price) : null
                      })
                    }
                  })
                }
              })
            }
          })
        }
      })
    },
    setPrice(itm, index = -1, field = null) {
      const self = this
      const price = self.calculatePrice(itm, index)

      if (self.activeTab === 2 && price.maxQunatityError && field !== null) {
        self.$notify({
          title: this.$i18n.t('core.validation_error'),
          text: this.$i18n.t('sandoz.max_quantity_exceed'),
          type: 'error'
        })

        itm.delivery[field].quantity = itm.delivery[field].previous_quantity
        return false
      } else if (self.activeTab === 3 && price.maxAdhocQuantityError && field !== null) {
        self.$notify({
          title: this.$i18n.t('core.validation_error'),
          text: this.$i18n.t('sandoz.max_adhoc_quantity_exceed'),
          type: 'error'
        })

        itm.delivery[field].quantity = itm.delivery[field].previous_quantity
        return false
      } else {
        itm.price = price.price
        itm.price_changes = price.price_changes
        self.$nextTick(function () {
          self.setSelectedItemPrice()
        });
      }

    },
    setQuantityToChild(itm, qtr, index = -1) {
      const self = this
      self.$nextTick(function () {
        if (itm.children && Object.keys(itm.children).length) {
          itm.children.forEach(function (subLine) {
            if (subLine.delivery && Object.keys(subLine.delivery).length) {
              if ((subLine.delivery[qtr] && subLine.child_qty)) {
                subLine.delivery[qtr].quantity = subLine.child_qty && itm.delivery[qtr].quantity !== null ? subLine.child_qty * itm.delivery[qtr].quantity : null
                self.$nextTick(function () {
                  self.setPrice(subLine, index, qtr)
                })
              }
            }

            if (subLine.children && Object.keys(subLine.children).length) {
              subLine.children.forEach(function (childLine) {
                if (childLine.delivery && Object.keys(childLine.delivery).length) {
                  if ((childLine.delivery[qtr] && childLine.child_qty)) {
                    childLine.delivery[qtr].quantity = childLine.child_qty && itm.delivery[qtr].quantity !== null ? childLine.child_qty * childLine.delivery[qtr].quantity : null
                    self.$nextTick(function () {
                      self.setPrice(childLine, index, qtr)
                    })
                  }
                }
              })
            }
          })
        }
      })
    },
    isGadgetOrBox(item) {
      const self = this
      let is = false
      self.$nextTick(function () {
        if (item.children && Object.keys(item.children).length) {
          item.children.forEach(function (subLine) {
            if (subLine.box_or_gadget === 'box') {
              is = true
            }

            if (subLine.children && Object.keys(subLine.children).length) {
              subLine.children.forEach(function (childLine) {
                if (childLine.box_or_gadget === 'gadget') {
                  is = true
                }
              })
            }
          })
        }
      })
      return is
    },
    setBoxQuantity(item, qtr, boxOrGadget, index, lineIndex) {
      const self = this
      if (!['box', 'gadget'].includes(boxOrGadget)) {
        return
      }

      self.$nextTick(function () {
        let boxes = 0
        let gadgets = {yearly: 0, q1: 0, q2: 0, q3: 0, q4: 0}
        let itemBoxes = null
        let gadgetBoxes = null
        if (item.children && Object.keys(item.children).length) {
          item.children.forEach(function (subLine) {
            if (subLine.box_or_gadget === 'box' && subLine.delivery && Object.keys(subLine.delivery).length) {
              if ((subLine.delivery.yearly && subLine.delivery.yearly.quantity > 0)) {
                boxes = boxes + parseInt(subLine.delivery.yearly.quantity)
              }
            }

            if (subLine.box_or_gadget === 'gadget' && subLine.delivery && Object.keys(subLine.delivery).length) {
              Object.keys(subLine.delivery).forEach(function (p) {
                if ((subLine.delivery[p] && subLine.delivery[p].quantity > 0)) {
                  gadgets[p] = gadgets[p] + parseInt(subLine.delivery[p].quantity)
                }
              })
            }

            if (subLine.children && Object.keys(subLine.children).length) {
              subLine.children.forEach(function (childLine) {
                if (childLine.box_or_gadget === 'gadget' && childLine.delivery && Object.keys(childLine.delivery).length) {
                  Object.keys(childLine.delivery).forEach(function (p) {
                    if ((childLine.delivery[p] && childLine.delivery[p].quantity > 0)) {
                      gadgets[p] = gadgets[p] + parseInt(childLine.delivery[p].quantity)
                    }
                  })
                }

                if (childLine.box_or_gadget === 'box' && childLine.delivery && Object.keys(childLine.delivery).length) {
                  if ((childLine.delivery.yearly && childLine.delivery.yearly.quantity > 0)) {
                    boxes = boxes + parseInt(childLine.delivery.yearly.quantity)
                  }
                }
              })
            }
          })
        }

        if (boxOrGadget === 'box') {
          Object.keys(item.delivery).forEach(function (p) {
            if ((item.delivery[p])) {
              gadgetBoxes = gadgets[p] ? gadgets[p] / 20 : null
              gadgetBoxes = gadgetBoxes ? gadgetBoxes.toString().split(".")[0] : null

              if (boxes < gadgetBoxes) {
                itemBoxes = boxes ? parseInt(boxes) : null
              } else {
                itemBoxes = gadgetBoxes ? parseInt(gadgetBoxes) : null
              }

              item.delivery[p].quantity = itemBoxes > 0 ? itemBoxes : null
              self.setPrice(item, index, qtr)
            }
          })
        } else if (boxOrGadget === 'gadget') {
          gadgetBoxes = gadgets[qtr] ? gadgets[qtr] / 20 : null
          gadgetBoxes = gadgetBoxes ? gadgetBoxes.toString().split(".")[0] : null

          if (boxes < gadgetBoxes) {
            itemBoxes = boxes ? parseInt(boxes) : null
          } else {
            itemBoxes = gadgetBoxes ? parseInt(gadgetBoxes) : null
          }

          if (item.delivery[qtr]) {
            item.delivery[qtr].quantity = itemBoxes > 0 ? itemBoxes : null
            self.setPrice(item, index, qtr)
          }
        }
        self.setHighLighter(item)
      })
    },
    calculatePrice(itm, index) {
      const self = this
      let price = null
      let priceChanges = {}
      let capBasePrice = null
      let adjustablePrice = 'yes'
      const address = self.item.addresses[index === -1 ? self.addressIndex : index]
      if (itm.base_price && Object.keys(itm.base_price).length) {
        itm.base_price.forEach(function (p) {
          if (p.sales_line_price_category && Object.keys(p.sales_line_price_category).length) {
            console.log(p.sales_line_price_category.category_type)
            if (p.sales_line_price_category.category_type === 'gadget_hcps') {
              if (p.price && self.isHCPSet && p.sales_line_price_category.price_category === self.item.type) {
                price = p.price
                capBasePrice = p.sales_line_price_category
                adjustablePrice = p.adjustable_price
              }
              priceChanges = p.price_changes
              return false
            }
          } else if (p.price_changes) {
            priceChanges = p.price_changes
            return false
          }
        })
      }

      if (capBasePrice !== null) {
        address.cap_base_price = capBasePrice
      }

      let quantity = null
      let yearlyQuantity = null
      if (itm.delivery && Object.keys(itm.delivery).length) {
        Object.keys(itm.delivery).forEach(function (p) {
          if ((itm.delivery[p] && itm.delivery[p].quantity <= 0) && (!self.isGadgetOrBox(itm) || self.isReadonly(itm, p))) {
            return false
          }

          if (itm.delivery[p].quantity) {
            quantity = quantity + parseInt(itm.delivery[p].quantity)
          }

          if (p === 'yearly') {
            yearlyQuantity = quantity
          }
        })
      }

      let numberOfHCPS = 1
      self.item.addresses.forEach(function (address) {
        if(address.address_type === 'master') {
          numberOfHCPS = address.number_of_hcps > 0 ? address.number_of_hcps : 1
        }
      })

      let maxQunatityError = false
      if ((itm.max_quantity !== '' || itm.max_quantity !== null) && itm.max_quantity > 0) {
        if ((parseInt(itm.max_quantity) * parseInt(numberOfHCPS)) < quantity) {
          maxQunatityError = true
        }
      }

      let maxAdhocQuantityError = false
      if ((itm.max_adhoc_items !== '' || itm.max_adhoc_items !== null) && itm.max_adhoc_items > 0) {
        if ((parseInt(itm.max_adhoc_items) * parseInt(numberOfHCPS)) < quantity) {
          maxAdhocQuantityError = true
        }
      }

      let newPrice = null
      if (priceChanges && priceChanges.price_changes && priceChanges.price_changes === 'any_price_allowed') {
        newPrice = itm.price * 1
      } else if (quantity && price) {
        if (adjustablePrice === 'yes') {
          let months = ((itm.valid_to_month - itm.valid_from_month) + 1) / 12
          let durationPrice = (price * months) * yearlyQuantity
          let qPrice = price * (quantity - yearlyQuantity)
          newPrice = parseFloat((durationPrice + qPrice)).toFixed(2)
        } else {
          newPrice = parseFloat(price * quantity).toFixed(2)
        }
      } else if (price) {
        if (adjustablePrice === 'yes') {
          let months = ((itm.valid_to_month - itm.valid_from_month) + 1) / 12
          let durationPrice = (price * months) * 1
          itm.item_price = parseFloat((durationPrice)).toFixed(2)
        }
      }

      return {
        'price': newPrice ? newPrice : null,
        'price_changes': priceChanges ? priceChanges : {},
        'maxQunatityError': maxQunatityError,
        'maxAdhocQuantityError': maxAdhocQuantityError
      }
    },
    setContractDateToItems() {
      const self = this
      const startDate = moment(self.item.contract_start)
      const expiredDate = moment(self.item.contract_expiration)

      let date = null
      let startMonth = null
      let startYear = null
      let endDate = null
      let endMonth = null
      let endYear = null
      if (startDate.isValid()) {
        date = startDate.date()
        startMonth = startDate.month() + 1
        startYear = startDate.year()
      }

      if (expiredDate.isValid()) {
        endDate = expiredDate.date()
        endMonth = expiredDate.month() + 1
        endYear = expiredDate.year()
      }

      startMonth = (startMonth < 10 ? '0' + startMonth : startMonth).toLocaleString()
      endMonth = (endMonth < 10 ? '0' + endMonth : endMonth).toLocaleString()

      if (self.item.addresses) {
        self.item.addresses.forEach(function (address, index) {
          if (address.address_type !== 'delivery') {
            return false
          }

          if (address.items) {
            address.items.forEach(function (line) {
              if (line.children) {
                line.children.forEach(function (subLine) {
                  if (subLine.children) {
                    subLine.children.forEach(function (childLine) {
                      childLine.valid_from_month = startYear != childLine.valid_from_year ? 1 : (childLine.valid_from_month ? (childLine.valid_from_changed ? childLine.valid_from_month : (childLine.id && !childLine.valid_from_changed ? childLine.valid_from_month : startMonth)) : startMonth)
                      childLine.valid_from_year = startYear != childLine.valid_from_year ? startYear : childLine.valid_from_year

                      childLine.valid_to_month = endYear != childLine.valid_to_year ? 12 : (childLine.valid_to_month ? (childLine.valid_to_changed ? childLine.valid_to_month : (childLine.id && !childLine.valid_to_changed ? childLine.valid_to_month : endMonth)) : endMonth)
                      childLine.valid_to_year = endYear != childLine.valid_to_year ? startYear : childLine.valid_to_year

                      self.$nextTick(function () {
                        self.setPrice(childLine, index)
                        self.setHighLighter(childLine)
                      })
                    })
                  }

                  subLine.valid_from_month = startYear != subLine.valid_from_year ? 1 : (subLine.valid_from_month ? (subLine.valid_from_changed ? subLine.valid_from_month : (subLine.id && !subLine.valid_from_changed ? subLine.valid_from_month : startMonth)) : startMonth)
                  subLine.valid_from_year = startYear != subLine.valid_from_year ? startYear : subLine.valid_from_year

                  subLine.valid_to_month = endYear != subLine.valid_to_year ? 12 : (subLine.valid_to_month ? (subLine.valid_to_changed ? subLine.valid_to_month : (subLine.id && !subLine.valid_to_changed ? subLine.valid_to_month : endMonth)) : endMonth)
                  subLine.valid_to_year = endYear != subLine.valid_to_year ? startYear : subLine.valid_to_year

                  self.$nextTick(function () {
                    self.setPrice(subLine, index)
                    self.setHighLighter(subLine)
                  })
                })
              }

              line.valid_from_month = startYear != line.valid_from_year ? 1 : (line.valid_from_month ? (line.valid_from_changed ? line.valid_from_month : (line.id && !line.valid_from_changed ? line.valid_from_month : startMonth)) : startMonth)
              line.valid_from_year = startYear != line.valid_from_year ? startYear : line.valid_from_year

              line.valid_to_month = endYear != line.valid_to_year ? 12 : (line.valid_to_month ? (line.valid_to_changed ? line.valid_to_month : (line.id && !line.valid_to_changed ? line.valid_to_month : endMonth)) : endMonth)
              line.valid_to_year = endYear != line.valid_to_year ? startYear : line.valid_to_year
              self.$nextTick(function () {
                if (!self.saving) {
                  self.setPrice(line, index)
                }

                self.setHighLighter(line)
              })
            })
          }
        })
      }
    },
    validatePrice(itm, index) {
      const self = this
      const basePrice = self.calculatePrice(itm, index)
      if (basePrice.price_changes && basePrice.price_changes.price_changes === 'no_changes_allowed') {
        this.$notify({
          title: this.$i18n.t('core.validation_error'),
          text: this.$i18n.t('sandoz.no_changes_allowed_error'),
          type: 'error'
        })
        itm.price = basePrice.price
        return false
      } else if (basePrice.price_changes && basePrice.price_changes.price_changes === 'minus_20_allowed') {
        const minPrice = parseFloat(((80 / 100) * basePrice.price).toFixed(0))
        if (itm.price < minPrice) {
          this.$notify({
            title: this.$i18n.t('core.validation_error'),
            text: this.$i18n.t('sandoz.minus_20_allowed_error'),
            type: 'error'
          })
          itm.price = minPrice
          return false
        }

        if (itm.price > basePrice.price) {
          this.$notify({
            title: this.$i18n.t('core.validation_error'),
            text: this.$i18n.t('sandoz.only_downward_error'),
            type: 'error'
          })
          itm.price = basePrice.price
          return false
        }
      } else if (basePrice.price_changes && basePrice.price_changes.price_changes === 'changes_allowed') {
        if (itm.price > basePrice.price) {
          this.$notify({
            title: this.$i18n.t('core.validation_error'),
            text: this.$i18n.t('sandoz.changes_allowed_error'),
            type: 'error'
          })
          itm.price = basePrice.price
          return false
        }
      } else if ((basePrice.price_changes && basePrice.price_changes.price_changes === 'any_price_allowed') &&
        (itm.price === null || itm.price <= 0)
      ) {
        self.$notify({
          title: this.$i18n.t('core.validation_error'),
          text: this.$i18n.t('sandoz.any_price_allowed_error'),
          type: 'error'
        })
        itm.price = basePrice.price
        return false
      }
    },
    setSelectedItemPrice() {
      const self = this
      let price = 0
      let countAddressCapExceed = 0
      self.marketingActivitiesAdhoc = 0
      self.marketingActivitiesStandard = 0
      self.item.addresses.forEach(function (address, key) {
        let addPrice = 0
        if (address.address_type === 'delivery') {
          address.items.forEach(function (item, key1) {
            if(item.item_visibility === 'both' || item.item_visibility === 'item') {
              let masterLinePrice = parseFloat(item.price) > 0 ? parseFloat(item.price) : 0
              addPrice = addPrice + parseFloat(masterLinePrice)
              price = parseFloat(price) + parseFloat(masterLinePrice)
              if (item.children && Object.keys(item.children).length) {
                if(item.item_visibility === 'both' || item.item_visibility === 'item') {
                  let childrenPrice = self.getChildSelectedItemPrice(item)
                  addPrice = addPrice + parseFloat(childrenPrice)
                  price = price + parseFloat(childrenPrice)
                }
              }
            }
          })

          address.adhoc_items.forEach(function (item, key2) {
            if(item.item_visibility === 'both' || item.item_visibility === 'adhoc_item') {
              let masterLinePrice = parseFloat(item.price) > 0 ? parseFloat(item.price) : 0
              addPrice = addPrice + parseFloat(masterLinePrice)
              self.marketingActivitiesAdhoc = parseFloat(self.marketingActivitiesAdhoc) + masterLinePrice
            }
          })

          if (address.cap_base_price && (self.item.status === 'Draft' || self.item.status === 'Feedback')) {
            let exceedCap = parseInt(address.cap_base_price.cap)
            if (exceedCap !== null && addPrice !== 0 && exceedCap < addPrice) {
              address.cap_exceeded = true
              countAddressCapExceed = countAddressCapExceed + 1
            } else {
              address.cap_exceeded = false
            }
          }
        }
      })

      if (self.item.status === 'Draft' || self.item.status === 'Feedback') {
        self.item.cap_exceeded = false
      }

      if (countAddressCapExceed > 0) {
        self.item.cap_exceeded = true
      }

      self.marketingActivitiesStandard = price
      self.item.marketing_activities = self.marketingActivitiesStandard + self.marketingActivitiesAdhoc
    },
    getChildSelectedItemPrice(item) {
      let childPrice = 0
      const self = this
      item.children.forEach(function (item, key1) {
        let masterLineChildPrice = parseFloat(item.price) > 0 ? parseFloat(item.price) : 0
        childPrice = parseFloat(childPrice) + parseFloat(masterLineChildPrice)
        if (item.children && Object.keys(item.children).length) {
          let childrenPrice = self.getChildSelectedItemPrice(item)
          childPrice = parseFloat(childPrice) + parseFloat(childrenPrice)
        }
      })

      return childPrice
    },
    addPreviousContract(contract) {
      this.item.previous_contract = contract.id
      this.item.previous = contract
      this.$refs.addPreviousContractModel.hide()
    },
    setPreviousContract(fromNewCustomer = false) {
      if (this.item.customer_external_id !== null && this.item.contract_year !== '' && this.item.type !== null) {
        var params = {
          customer_external_id: this.item.customer_external_id,
          contract_year: this.item.contract_year,
          type: this.item.type
        }
        let url = '/api/sandoz/gadget/contracts/get-previous-contract';
        axios.post(url, params)
          .then((response) => {
            const self = this
            let previousContract = response.data.previousContract
            if (previousContract) {
              self.item.previous_contract = previousContract.id
              self.item.previous = previousContract
              if (!fromNewCustomer) {
                self.item.new_customer = null
              }
            } else {
              self.item.previous_contract = null
              self.item.previous = null
              if (!fromNewCustomer) {
                self.item.new_customer = 'x'
              }
            }
          })
      }
    },
    addItemsToAddresses(reset = true) {
      const _self = this
      this.$nextTick(function () {
        if (_self.item.addresses) {
          _self.item.addresses.forEach(function (address, index) {
            if (address.address_type !== 'delivery') {
              return false
            }

            if (reset || _self.$route.params.id === 'new') {
              _self.item.addresses[index].items = []
              _self.item.addresses[index].adhoc_items = []
            }

            if (!address.items.length) {
              _self.addItemsToAddress(index, reset)
            }

            var sortOrder = 1
            if (address.items.length && _self.$route.params.id !== 'new') {
              address.items.forEach(function (item) {
                if(item.item_visibility === 'both' || item.item_visibility === 'item') {
                  const itemPrice = _self.addItemPrice(item, index)
                  const price = _self.calculatePrice(item, index)

                  item.item_price = itemPrice.price
                  item.price = price.price
                  item.price_changes = price.price_changes
                  item.sort_order = sortOrder

                  if(item.product && item.product.product_master && item.product.product_master.adhoc_delivery_per_quarter && item.delivery.yearly) {
                    item.delivery.yearly.planned_delivery = _self.getNextQuarterDate()
                  }

                  sortOrder++

                  _self.setHighLighter(item)
                  if (item.children && Object.keys(item.children).length) {
                    item.children.sort((a, b) => a.sort_order - b.sort_order).forEach(function (subItem) {
                      if(subItem.item_visibility === 'both' || subItem.item_visibility === 'item') {
                        const subItemPrice = _self.addItemPrice(subItem, index)
                        const subPrice = _self.calculatePrice(subItem, index)

                        subItem.item_price = subItemPrice.price
                        subItem.price = subPrice.price
                        subItem.price_changes = subPrice.price_changes
                        subItem.sort_order = sortOrder
                        if(subItem.product && subItem.product.product_master && subItem.product.product_master.adhoc_delivery_per_quarter && subItem.delivery.yearly) {
                          subItem.delivery.yearly.planned_delivery = _self.getNextQuarterDate()
                        }
                        sortOrder++

                        _self.setHighLighter(subItem)
                        if (subItem.children && Object.keys(subItem.children).length) {
                          subItem.children.sort((a, b) => a.sort_order - b.sort_order).forEach(function (childItem) {
                            if(childItem.item_visibility === 'both' || childItem.item_visibility === 'item') {
                              const childItemPrice = _self.addItemPrice(childItem, index)
                              const childPrice = _self.calculatePrice(childItem, index)

                              childItem.item_price = childItemPrice.price
                              childItem.price = childPrice.price
                              childItem.price_changes = childPrice.price_changes
                              childItem.sort_order = sortOrder
                              if(childItem.product && childItem.product.product_master && childItem.product.product_master.adhoc_delivery_per_quarter && childItem.delivery.yearly) {
                                childItem.delivery.yearly.planned_delivery = _self.getNextQuarterDate()
                              }
                              sortOrder++
                            }
                          })
                        }
                      }
                    })
                  }
                }
              })
            }

            if (address.adhoc_items.length && _self.$route.params.id !== 'new') {
              address.adhoc_items.forEach(function (item) {
                if(item.item_visibility === 'both' || item.item_visibility === 'adhoc_item') {
                  const itemPrice = _self.addItemPrice(item, index)
                  const price = _self.calculatePrice(item, index, true)

                  item.item_price = itemPrice.price
                  item.price_changes = price.price_changes
                  item.sort_order = sortOrder

                  if(item.product && item.product.product_master && item.product.product_master.adhoc_delivery_per_quarter && item.delivery.yearly.planned_delivery === null) {
                    item.delivery.yearly.planned_delivery = _self.getNextQuarterDate()
                  }
                  
                  sortOrder++
                }
              })
            }
          })
        }
      })
    },
    addItemsToAddress(index) {
      const _self = this
      if (!this.item.type) {
        return
      }

      if (_self.addItemsToAddressFlag && _self.addItemsToAddressFlagIndex === index) {
        return
      }

      _self.addItemsToAddressFlag = true
      _self.addItemsToAddressFlagIndex = index
      let url = '/api/sandoz/gadget/items?c_type=' + _self.item.type + '&c_start=' + _self.item.contract_start + '&c_end=' + _self.item.contract_expiration + '&c_lang=' + _self.item.language + '&c_year=' + _self.item.contract_year
      axios
        .get(url)
        .then((response) => {
          var sortOrder = 1
          response.data.forEach(function (item) {
            const itemPrice = _self.addItemPrice(item, index)
            const price = _self.calculatePrice(item, index)

            item.item_price = itemPrice.price
            item.price = price.price
            item.price_changes = price.price_changes
            item.sort_order = sortOrder

            if(item.product && item.product.product_master && item.product.product_master.adhoc_delivery_per_quarter && item.delivery.yearly.planned_delivery === null) {
              item.delivery.yearly.planned_delivery = _self.getNextQuarterDate()
            }
            sortOrder++

            _self.setHighLighter(item)
            if (item.children && Object.keys(item.children).length) {
              item.children.sort((a, b) => a.sort_order - b.sort_order).forEach(function (subItem) {
                const subItemPrice = _self.addItemPrice(subItem, index)
                const subPrice = _self.calculatePrice(subItem, index)

                subItem.item_price = subItemPrice.price
                subItem.price = subPrice.price
                subItem.price_changes = subPrice.price_changes
                subItem.sort_order = sortOrder
                if(subItem.product && subItem.product.product_master && subItem.product.product_master.adhoc_delivery_per_quarter && subItem.delivery.yearly.planned_delivery === null) {
                  subItem.delivery.yearly.planned_delivery = _self.getNextQuarterDate()
                }
                sortOrder++

                _self.setHighLighter(subItem)
                if (subItem.children && Object.keys(subItem.children).length) {
                  subItem.children.sort((a, b) => a.sort_order - b.sort_order).forEach(function (childItem) {
                    const childItemPrice = _self.addItemPrice(childItem, index)
                    const childPrice = _self.calculatePrice(childItem, index)

                    childItem.item_price = childItemPrice.price
                    childItem.price = childPrice.price
                    childItem.price_changes = childPrice.price_changes
                    childItem.sort_order = sortOrder
                    if(childItem.product && childItem.product.product_master && childItem.product.product_master.adhoc_delivery_per_quarter && childItem.delivery.yearly.planned_delivery === null) {
                      childItem.delivery.yearly.planned_delivery = _self.getNextQuarterDate()
                    }
                    sortOrder++
                  })
                }
              })
            }

            _self.item.addresses[index].items.push(item)
          })

          _self.$nextTick(() => {
            _self.setQuantityChildParent()
            _self.setQuantityToChildSpecialLoad()
          })
          _self.addItemsToAddressFlag = false
          _self.addItemsToAddressFlagIndex = null
        })
    },
    addItemPrice(itm, index = -1) {
      const self = this
      let itemPrice = null
      let priceChanges = {}
      const address = self.item.addresses[index === -1 ? self.addressIndex : index]
      if (itm.base_price && Object.keys(itm.base_price).length) {
        itm.base_price.forEach(function (p) {
          if (p.sales_line_price_category && Object.keys(p.sales_line_price_category).length) {
            if (p.sales_line_price_category.category_type === 'gadget_hcps') {
              itemPrice = p.price
              priceChanges = p.price_changes
              return false
            }
          } else if (p.price_changes) {
            priceChanges = p.price_changes
            return false
          }
        })
      }

      return {'price': itemPrice, 'price_changes': priceChanges ? priceChanges : {}}
    },
    setHighLighter(item) {
      const self = this

      if (!['set'].includes(item.box_or_gadget)) {
        return
      }

      self.$nextTick(function () {
        let boxes = 0
        let gadgets = {yearly: 0, q1: 0, q2: 0, q3: 0, q4: 0}
        let quaterDisabled = {yearly: true, q1: true, q2: true, q3: true, q4: true}
        let gadgetBoxes = null
        if (item.children && Object.keys(item.children).length) {
          item.children.forEach(function (subLine) {
            if (subLine.box_or_gadget === 'box' && subLine.delivery && Object.keys(subLine.delivery).length) {
              if ((subLine.delivery.yearly && subLine.delivery.yearly.quantity > 0)) {
                boxes = boxes + parseInt(subLine.delivery.yearly.quantity)
              }
            }

            if (subLine.box_or_gadget === 'gadget' && subLine.delivery && Object.keys(subLine.delivery).length) {
              Object.keys(subLine.delivery).forEach(function (p) {
                if ((subLine.delivery[p] && subLine.delivery[p].quantity > 0)) {
                  gadgets[p] = gadgets[p] + parseInt(subLine.delivery[p].quantity)
                }

                if (!self.isReadonly(subLine, p, true) && quaterDisabled[p] === true) {
                  quaterDisabled[p] = false
                }
              })
            }

            if (subLine.children && Object.keys(subLine.children).length) {
              subLine.children.forEach(function (childLine) {
                if (childLine.box_or_gadget === 'gadget' && childLine.delivery && Object.keys(childLine.delivery).length) {
                  Object.keys(childLine.delivery).forEach(function (p) {
                    if ((childLine.delivery[p] && childLine.delivery[p].quantity > 0)) {
                      gadgets[p] = gadgets[p] + parseInt(childLine.delivery[p].quantity)
                    }

                    if (!self.isReadonly(childLine, p, true) && quaterDisabled[p] === true) {
                      quaterDisabled[p] = false
                    }
                  })
                }

                if (childLine.box_or_gadget === 'box' && childLine.delivery && Object.keys(childLine.delivery).length) {
                  if ((childLine.delivery.yearly && childLine.delivery.yearly.quantity > 0)) {
                    boxes = boxes + parseInt(childLine.delivery.yearly.quantity)
                  }
                }
              })
            }
          })
        }

        Object.keys(item.delivery).forEach(function (p) {
          if ((item.delivery[p])) {
            item.delivery[p].error = false
            if (parseInt(boxes) > 0 && quaterDisabled[p] === false && (gadgets[p] === 0 || ((parseInt(boxes) * 20) > gadgets[p]))) {
              item.delivery[p].error = true
            }
          }
        })
      })
    },
    pdfContract() {
      this.saving = true
      this.$root.$loading.start()
      let delAddress = null
      this.item.addresses.forEach(function (address, key) {
        if (address.address_type === 'master' && delAddress === null) {
          delAddress = address
        }
      })

      let documentName = this.item.contract_no;
      if (this.item.contract_version !== null) {
        documentName += '-' + this.item.contract_version
      } else {
        documentName += '-1';
      }

      if (delAddress) {
        documentName += '-' + delAddress.company_name + ' - ' + delAddress.city
      }

      axios.post('/api/sandoz/generate-pdf2', {id: this.$route.params.id}, {responseType: 'arraybuffer'})
        .then((response) => {
          require('downloadjs')(
            response.data,
            documentName + '.pdf',
            'application/pdf'
          )
          this.$root.$loading.finish()
          this.saving = false
        }).catch((error) => {
        this.$root.$loading.finish()
        this.saving = false
        console.log(error)
      })
    },
    toggleAccordion(address, item) {
      const index = this.getAccordion(address, item)
      if (index !== -1) {
        this.accordionItems.splice(index, 1);
      } else {
        this.accordionItems.push(address + '' + item)
      }
    },
    getAccordion(address, item) {
      return this.accordionItems.indexOf(address + '' + item)
    },
    showDuplicateContract() {
      const routeData = this.$router.resolve({path: '/sandoz/gadget/contracts/' + this.showContract})
      window.open(routeData.href, '_blank')
    },
    checkLineChildren(line) {
      if (line.children && Object.keys(line.children).length) {
        return true
      }
      return false
    },
    setQuantityChildParent(fromland = 0) {
      if (this.item.addresses) {
        const self = this
        let quaters = ['price', 'yearly', 'q1', 'q2', 'q3', 'q4'];
        self.item.addresses.forEach(function (address, index) {
          if (address.address_type === 'delivery') {
            address.items.forEach(function (line, lineIndex) {
              let syncquatersWithChidren = []
              let quantities = {
                subItems: {
                  q1_quantity: 0,
                  q2_quantity: 0,
                  q3_quantity: 0,
                  q4_quantity: 0
                }
              }
              quaters.forEach(function (q, qindex) {
                if (fromland === 0 && !self.isReadonly(line, q) && q !== 'price') {
                  self.setQuantityToChild(line, q, index)
                }

                line['sync_quarter_' + q] = false
              })

              if (line.children && Object.keys(line.children).length) {
                line.children.forEach(function (subLine, subLineIndex) {
                  quaters.forEach(function (q, qindex) {

                    if (subLine.sync_quater_with_children) {

                      var subLineQuantity = subLine.delivery && subLine.delivery[q] ? subLine.delivery[q].quantity : null
                      subLine['sync_quarter_' + q] = false

                      if (subLineQuantity !== null && syncquatersWithChidren.includes(q)) {
                        subLine['sync_quarter_' + q] = true
                        line['sync_quarter_' + q] = true
                      }

                      if (subLineQuantity !== null && !syncquatersWithChidren.includes(q)) {
                        syncquatersWithChidren.push(q)
                      }
                    }

                    if (!self.isReadonly(subLine, q, true) && q !== 'price') {
                      if (!!subLine.write_qty_from_child_to_parent) {
                        if (line.delivery) {
                          var subLineQuantity = subLine.delivery ? subLine.delivery[q].quantity : 0
                          quantities.subItems[q + '_quantity'] += subLineQuantity
                        }
                      }

                      self.setQuantityToParent(line, subLine, q, index)
                      if (fromland === 0) {
                        self.setQuantityToChild(subLine, q, subLineIndex)
                        self.setBoxQuantity(line, q, subLine.box_or_gadget, index)
                      }
                    }

                    if (q !== 'price' && subLine[q + '_quantity'] === true && !self.copyMasterProductToChild.includes(q)) {
                      self.copyMasterProductToChild.push(q)
                    }
                  })

                  // to sum of child quantity to parent
                  self.$nextTick(function () {
                    var quaterQuantity = false
                    quaters.forEach(function (q, qindex) {
                      if (quantities.subItems[q + '_quantity'] > 0) {
                        if (line.digitial_screen_category === true) {
                          quaterQuantity = true
                        }
                        line.delivery[q].quantity = quantities.subItems[q + '_quantity']
                        self.setPrice(line, index, q)
                      }
                    })

                    // Set orange background to digitial_screen_category products
                    if (quaterQuantity) {
                      quaters.forEach(function (q, qindex) {
                        var quaterStartEndMonthData = self.getQuaterStartEndMonth(q);
                        if (q !== 'price' && (quaterStartEndMonthData.qStartMonth !== null && quaterStartEndMonthData.qEndMonth !== null && line.valid_from_month <= quaterStartEndMonthData.qEndMonth && line.valid_to_month >= quaterStartEndMonthData.qStartMonth) && line.delivery[q] && (line.delivery[q].quantity === null || line.delivery[q].quantity === 0)) {
                          line.delivery[q].error = true
                        } else {
                          if (line.delivery[q]) {
                            line.delivery[q].error = false
                          }
                        }
                        self.setPrice(line, index, q)
                      })
                    }
                  })

                  if (subLine.children && Object.keys(subLine.children).length) {
                    subLine.children.forEach(function (childLine, childLineIndex) {
                      quaters.forEach(function (q, qindex) {
                        if (!self.isReadonly(childLine, q, true) && q !== 'price') {
                          self.setQuantityToParent(subLine, childLine, q, index),
                            self.setBoxQuantity(line, q, childLine.box_or_gadget, index)
                        }
                      })
                    })
                  }
                })
              }
            })
          }
        })
      }
    },
    setQuantityToChildSpecialLoad() {
      if (this.item.addresses) {
        const self = this
        self.$nextTick(function () {
          self.item.addresses.forEach(function (address, index) {
            if (address.address_type === 'delivery') {
              address.items.forEach(function (line, lineIndex) {
                if (line.digitial_screen_category === true && line.children && Object.keys(line.children).length) {
                  line.children.forEach(function (subLine, subLineIndex) {
                    if (subLine.digitial_screen_category === true) {
                      let quaters = ['q1', 'q2', 'q3', 'q4'];
                      var totalQuantity = 0
                      quaters.forEach(function (q, qindex) {
                        if (line.delivery[q] && line.delivery[q].quantity > 0) {
                          if (parseInt(line.delivery[q].quantity) > totalQuantity) {
                            totalQuantity = parseInt(line.delivery[q].quantity)
                          }
                        }
                      })

                      if (totalQuantity > 0) {
                        subLine.delivery['yearly'].quantity = totalQuantity
                      } else {
                        subLine.delivery['yearly'].quantity = null
                      }
                    }
                  })
                }
              })
            }
          })
        })
      }
    },
    setQuantityToChildSpecial(itm, qtr, index) {
      const self = this
      self.$nextTick(function () {
        if (itm.digitial_screen_category === true) {
          if (itm.children && Object.keys(itm.children).length) {
            itm.children.forEach(function (subLine) {
              if (subLine.digitial_screen_category === true) {
                let quaters = ['q1', 'q2', 'q3', 'q4'];
                var totalQuantity = 0
                quaters.forEach(function (q, qindex) {
                  if (itm.delivery[q] && itm.delivery[q].quantity > 0) {
                    if (parseInt(itm.delivery[q].quantity) > totalQuantity) {
                      totalQuantity = parseInt(itm.delivery[q].quantity)
                    }
                  }
                })

                if (totalQuantity > 0) {
                  subLine.delivery['yearly'].quantity = totalQuantity
                } else {
                  subLine.delivery['yearly'].quantity = null
                }
              }
            })
          }
        }
      })
    },
    checkIndeterminantCheckbox() {
      if (this.item.addresses) {
        const self = this

        var determError = false;
        self.determErrorID = []
        self.item.addresses.forEach(function (address, index) {
          if (address.address_type === 'delivery') {
            address.items.forEach(function (line, lineIndex) {
              if (line.type === 'marketing_activity' && line.contract_line_exist_attribute === 'indeterminate' && (line.exists_attribute_required || line.exist_value !== null) && (line.delivery && line.delivery['yearly'].quantity !== null || line.delivery['q1'].quantity !== null || line.delivery['q2'].quantity !== null || line.delivery['q3'].quantity !== null || line.delivery['q4'].quantity !== null)) {
                determError = true;
                self.determErrorID.push(address.id + '-' + line.product.id)
              }

              if (line.children && Object.keys(line.children).length) {
                line.children.forEach(function (subLine, subLineIndex) {

                  if (subLine.type === 'marketing_activity' && subLine.contract_line_exist_attribute === 'indeterminate' && (subLine.exists_attribute_required || subLine.exist_value !== null) && (subLine.delivery && subLine.delivery['yearly'].quantity !== null || subLine.delivery['q1'].quantity !== null || subLine.delivery['q2'].quantity !== null || subLine.delivery['q3'].quantity !== null || subLine.delivery['q4'].quantity !== null)) {
                    determError = true;
                    self.determErrorID.push(address.id + '-' + subLine.product.id)
                  }

                  if (subLine.children && Object.keys(subLine.children).length) {
                    subLine.children.forEach(function (childLine, childLineIndex) {
                      if (childLine.type === 'marketing_activity' && childLine.contract_line_exist_attribute === 'indeterminate' && (childLine.exists_attribute_required || childLine.exist_value !== null) && (childLine.delivery && childLine.delivery['yearly'].quantity !== null || childLine.delivery['q1'].quantity !== null || childLine.delivery['q2'].quantity !== null || childLine.delivery['q3'].quantity !== null || childLine.delivery['q4'].quantity !== null)) {
                        determError = true;
                        self.determErrorID.push(address.id + '-' + childLine.product.id)
                      }
                    })
                  }
                })
              }
            })
          }
        })

        return determError
      }
    },
    setTitleItems() {
      if (this.item.language === 'DE') {
        this.titleItems = [
          {value: null, text: 'Partnertitel auswählen'},
          {value: 'Inhaber', text: 'Inhaber'},
          {value: 'Inhaberin', text: 'Inhaberin'},
          {value: 'Dr. med.', text: 'Dr. med.'},
          {value: 'Geschäftsführer', text: 'Geschäftsführer'},
          {value: 'Geschäftsführerin', text: 'Geschäftsführerin'},
          {value: 'FMH Allgemeine Innere Medizin', text: 'FMH Allgemeine Innere Medizin'}
        ]
      } else if (this.item.language === 'FR') {
        this.titleItems = [
          {value: null, text: 'Sélectionnez le titre du partenaire'},
          {value: 'Propriétaire', text: 'Propriétaire'},
          {value: 'Pharmacienne responsable', text: 'Pharmacienne responsable'},
          {value: 'Pharmacien responsable', text: 'Pharmacien responsable'},
          {value: 'Pharmacienne', text: 'Pharmacienne'},
          {value: 'Pharmacien', text: 'Pharmacien'},
          {value: 'Dr. med.', text: 'Dr. med.'}
        ]

      } else if (this.item.language === 'IT') {
        this.titleItems = [
          {value: null, text: 'Seleziona il titolo del partner'},
          {value: 'Gerente', text: 'Gerente'},
          {value: 'Proprietario', text: 'Proprietario'},
          {value: 'Proprietaria', text: 'Proprietaria'},
          {value: 'Dr. med.', text: 'Dr. med.'}
        ]
      }
    },
    changeContractDuration() {
      const startDate = moment(this.item.contract_start)
      const startYear = startDate.format('YYYY')
      if (startYear !== this.item.contract_year) {
        this.item.contract_start = this.item.contract_year + '-01-01'
        this.item.contract_expiration = this.item.contract_year + '-12-31'
      }
    },
    loadplanData() {
      if (this.item.contract_year && this.item.type && this.item.customer_external_id && (this.item.status === 'Draft' || this.item.status === 'Feedback')) {
        let url = '/api/loadplanData?type=' + this.item.type + '&year=' + this.item.contract_year + '&external_id=' + this.item.customer_external_id
        axios
          .get(url)
          .then((response) => {
            var planData = response.data.planData
            this.planData = planData
            if (planData) {
              this.item.plan_outlook = parseInt(planData.turnover_actual)
              if (planData.outlook != "" && planData.outlook != "0") {
                this.item.plan_turnover_actual = parseInt(planData.outlook)
              } else {
                this.item.plan_turnover_actual = null
              }

              this.item.plan_turnover_expectation = planData.turnover_expectation !== null ? this.calculatePriceBasedonDuration(parseInt(planData.turnover_expectation)) : null
              this.item.plan_target_invest = planData.target_invest !== null ? this.calculatePriceBasedonDuration(parseInt(planData.target_invest)) : null
              this.item.plan_turnover_actual = this.item.plan_turnover_actual !== null ? this.calculatePriceBasedonDuration(parseInt(this.item.plan_turnover_actual)) : null
              this.item.plan_target_discount = planData.target_discount !== null ? this.calculatePriceBasedonDuration(parseInt(planData.target_discount)) : null

              // set planned activity percentage
              if (this.item.plan_turnover_expectation !== 0 && this.item.plan_turnover_expectation !== null && this.item.plan_target_invest !== 0 && this.item.plan_target_invest !== null) {
                this.marketing_activities_percentage = this.item.plan_target_invest / this.item.plan_turnover_expectation
              }

              if (this.$route.params.id === 'new' || parseInt(this.item.turnover_expectation) === 0) {
                this.item.turnover_expectation = parseInt(planData.turnover_expectation)
              }

              if ((this.$route.params.id === 'new' && parseInt(this.item.marketing_activities_maximum) === 0) || parseInt(this.item.marketing_activities_maximum) === 0) {
                this.item.marketing_activities_maximum = parseInt(planData.target_invest)
              }

              if (this.$route.params.id === 'new' || Number.isNaN(this.item.turnover) || isNaN(parseFloat(this.item.turnover)) || parseInt(this.item.turnover) === 0) {
                if (this.checkTurnOverReadonly()) {
                  this.item.turnover = this.item.plan_turnover_actual
                }
              }
            } else {
              this.item.plan_turnover_expectation = null
              this.item.plan_target_invest = null
              this.item.plan_target_discount = null
              this.item.plan_turnover_actual = null
              this.marketing_activities_percentage = null
              this.item.deviation_outside_margin = null


              if (this.$route.params.id === 'new') {
                this.item.turnover_expectation = 0
                this.item.marketing_activities_maximum = 0
              }
            }

            this.$nextTick(() => {
              this.calculatePlanTurnOver()
              this.calculatePlanTurnOverExpectation()
              this.calculatePlanTargetInvest()
              this.calculatePlanTargetDiscount()
            })
          })
      }
    },
    calculatePlanTurnOver() {
      if (this.turnoverExpectionPercentageBaseline !== null && this.item.sales_line) {
        var deviation_min_growth = this.item.sales_line.deviation_min_growth
        if (this.item.sales_line.deviation_min_growth !== null && this.item.sales_line.deviation_min_growth !== 0) {
          var deviation_min_growth = parseFloat(this.item.sales_line.deviation_min_growth * 100).toFixed(2)
          var turnoverExpectationBase = parseFloat(this.turnoverExpectionPercentageBaseline.replace('%', '')).toFixed(2)
          if (parseFloat(turnoverExpectationBase) < parseFloat(deviation_min_growth)) {
            this.plan_turnover_outside_range = true
            return 'text-danger';
          } else {
            this.plan_turnover_outside_range = false
            return 'text-muted';
          }
        }
        return 'text-muted';
      }
    },
    calculatePlanTurnOverExpectation() {
      var planTurnOverExpectation = null
      if (this.item.plan_turnover_expectation !== 0 && this.item.plan_turnover_expectation !== null) {
        planTurnOverExpectation = this.item.plan_turnover_expectation
      }

      var contractTurnOverExpectation = parseInt(this.item.turnover_expectation)

      if (contractTurnOverExpectation !== 0 && planTurnOverExpectation !== null && this.item.sales_line) {

        if (contractTurnOverExpectation < parseInt(planTurnOverExpectation)) {
          var rangePercentage = this.checkDifferenceAndGetPercDeviation(contractTurnOverExpectation)
          if (rangePercentage !== null && rangePercentage !== 0 && rangePercentage !== 0.00) {
            this.plan_turnover_expectation_condition = true
            var maxDeviationValue = parseInt(planTurnOverExpectation) - (parseInt(planTurnOverExpectation) * rangePercentage)
            if (parseFloat(contractTurnOverExpectation) < parseFloat(maxDeviationValue)) {
              this.item.plan_deviation_skip_approval = false
              this.plan_turnover_expectation_outside_range = true
              return 'text-danger';
            } else {
              this.plan_turnover_expectation_outside_range = null
              return 'text-muted';
            }
          }
        } else {
          this.plan_turnover_expectation_condition = false
          this.plan_turnover_expectation_outside_range = null
          return 'text-muted';
        }
      } else {
        this.plan_turnover_expectation_outside_range = null
      }
      return 'text-muted';
    },
    calculatePlanTargetInvest() {
      var planTargetInvest = null
      if (this.item.plan_target_invest !== 0 && this.item.plan_target_invest !== null) {
        planTargetInvest = this.item.plan_target_invest
      }
      var contractTargetInvest = parseInt(this.item.marketing_activities_maximum)
      if (contractTargetInvest !== 0 && planTargetInvest !== null && this.item.sales_line) {
        if (contractTargetInvest > parseInt(planTargetInvest)) {
          var rangePercentage = this.checkDifferenceAndGetPercDeviation(contractTargetInvest)
          if (rangePercentage !== null && rangePercentage !== 0 && rangePercentage !== 0.00) {
            this.plan_invest_condition = true
            var maxDeviationValue = parseInt(planTargetInvest) + (parseInt(planTargetInvest) * rangePercentage)
            if (parseFloat(contractTargetInvest) > parseFloat(maxDeviationValue)) {
              this.item.plan_deviation_skip_approval = false
              this.plan_invest_outside_range = true
              return 'text-danger';
            } else {
              this.plan_invest_outside_range = null
              return 'text-muted';
            }
          }
        } else {
          this.plan_invest_condition = false
          this.plan_invest_outside_range = null
          return 'text-muted';
        }
      } else {
        this.plan_invest_outside_range = null
      }
      return 'text-muted';
    },
    calculatePlanTargetDiscount() {
      var planTargetDiscount = null
      if (this.item.plan_target_discount !== 0 && this.item.plan_target_discount !== null) {
        planTargetDiscount = this.item.plan_target_discount
      }

      var contractTargetDiscount = parseInt(this.item.discount)
      if (contractTargetDiscount !== 0 && planTargetDiscount !== null && planTargetDiscount != 0.00 && this.item.sales_line) {
        if (contractTargetDiscount > parseInt(planTargetDiscount)) {
          var rangePercentage = this.checkDifferenceAndGetPercDeviation(contractTargetDiscount)
          if (rangePercentage !== null && rangePercentage !== 0 && rangePercentage !== 0.00) {
            this.plan_discount_condition = true
            var maxDeviationValue = parseInt(planTargetDiscount) + (parseInt(planTargetDiscount) * rangePercentage)
            if (parseFloat(contractTargetDiscount) > parseFloat(maxDeviationValue)) {
              this.item.plan_deviation_skip_approval = false
              this.plan_discount_outside_range = true
              return 'text-danger';
            } else {
              this.plan_discount_outside_range = null
              return 'text-muted';
            }
          }
        } else {
          this.plan_discount_condition = false
          this.plan_discount_outside_range = null
          return 'text-muted';
        }
      } else {
        this.plan_discount_outside_range = null
      }
      return 'text-muted';
    },
    marketingActivityAdhocAvailable() {
      if(!this.item) {
        return 0
      }
      this.item.marketing_activities_maximum = Number.isNaN(this.item.marketing_activities_maximum) || isNaN(parseFloat(this.item.marketing_activities_maximum)) ? 0 : parseFloat(this.item.marketing_activities_maximum)
      return this.item.marketing_activities_maximum - (this.marketingActivitiesStandard + this.marketingActivitiesAdhoc)
    },
    checkTurnOverReadonly() {
      var check = false
      if (this.readonly || (!Number.isNaN(this.item.plan_turnover_actual) && !isNaN(parseFloat(this.item.plan_turnover_actual)) && this.item.plan_turnover_actual !== 0 && this.item.plan_turnover_actual !== null)) {
        check = true
      }
      return check
    },
    calculatePriceBasedonDuration(val) {
      // if (val !== null && val !== 0 && val !== 0.00 && this.item && this.$route.params.id === 'new') {
      //   var contractStart = this.item.contract_start
      //   var contractExpiration = this.item.contract_expiration
      //   contractStart = contractStart === null ? 12 : parseInt(moment(contractStart).format('MM'))
      //   contractExpiration = contractExpiration === null ? 12 : parseInt(moment(contractExpiration).format('MM'))
      //   var durationVal = (val / 12) * ((contractExpiration - contractStart) + 1)
      //   return durationVal
      // }
      return val
    },
    checkDifferenceAndGetPercDeviation(val) {
      if (this.item.sales_line) {
        if (val > 0 && val <= 10000) {
          return this.item.sales_line.deviation_range_1
        } else if (val > 10000 && val <= 20000) {
          return this.item.sales_line.deviation_range_2
        } else if (val > 20000) {
          return this.item.sales_line.deviation_range_3
        }
      }
      return null
    },
    getQuaterStartEndMonth(q) {
      var qStartMonth = null
      var qEndMonth = null
      switch (q) {
        case 'q1':
          qStartMonth = 1
          qEndMonth = 3
          break
        case 'q2':
          qStartMonth = 4
          qEndMonth = 6
          break
        case 'q3':
          qStartMonth = 7
          qEndMonth = 9
          break
        case 'q4':
          qStartMonth = 10
          qEndMonth = 12
          break
        case 'yearly':
          break
      }

      var quaterData = {
        'qStartMonth': qStartMonth,
        'qEndMonth': qEndMonth
      }

      return quaterData
    },
    linkValidate(link) {
      var linkUpdated = (link.indexOf('://') === -1) ? '//' + link : link;
      return linkUpdated
    },
    download(pdf = null) {
      axios.post('/api/sandoz/contract_pdfs/download', {
        'id': pdf.id
      }, {responseType: 'arraybuffer'})
        .then((response) => {
          require('downloadjs')(response.data,
            pdf.file_name, 'application/pdf'
          )
        }).catch((error) => {
        console.log(error)
      })
    },
    getPlanDataTurnoverActual() {
      if (this.planData && (this.item.status === 'Draft' || this.item.status === 'Feedback')) {
        if (this.planData.turnover_actual !== null) {
          var planBaseline = this.calculatePriceBasedonDuration(parseInt(this.planData.turnover_actual))
          this.item.plan_outlook = planBaseline
          return planBaseline
        }
      } else if (this.item.plan_outlook !== null && this.item.plan_outlook !== '') {
        return this.calculatePriceBasedonDuration(parseInt(this.item.plan_outlook))
      }
      return null
    },
    showItems (index) {
      const _self = this
      if (!this.item.type) {
        return
      }

      _self.itemList = []
      _self.addItemsToAddressFlag = true
      _self.addItemsToAddressFlagIndex = index
      let url = '/api/sandoz/gadget/items?c_type=' + _self.item.type + '&c_start=' + _self.item.contract_start + '&c_end=' + _self.item.contract_expiration + '&c_lang=' + _self.item.language + '&c_year=' + _self.item.contract_year
      axios
        .get(url)
        .then((response) => {
          var sortOrder = 1
          response.data.forEach(function (item) {
            const itemPrice = _self.addItemPrice(item, index)
            const price = _self.calculatePrice(item, index, true)
            item.item_price = itemPrice.price
            item.price = price.price
            item.price_changes = price.price_changes
            item.sort_order = sortOrder

            if(item.product && item.product.product_master && item.product.product_master.adhoc_delivery_per_quarter && item.delivery.yearly) {
              item.delivery.yearly.planned_delivery = _self.getNextQuarterDate()
            }

            sortOrder++

            _self.itemList.push(item)
          })
          _self.$refs.itemModel.show()
        })
    },
    selectItem (item) {
      this.item.addresses[this.addItemsToAddressFlagIndex].adhoc_items.push(item)
      this.addItemsToAddressFlag = false
      this.addItemsToAddressFlagIndex = null
      this.isAdHocDraft()
      this.$refs.itemModel.hide()
      this.disableUploadButton = false
    },
    isAdHocDraft () {
      const _self = this
      let isError = false
      if (_self.item && _self.item.addresses) {
        _self.item.addresses.forEach(function (address, index) {
          if (address.address_type !== 'delivery') {
            return false
          }

          if (address.adhoc_items.length) {
            address.adhoc_items.forEach(function (itm) {
              if (itm.delivery && Object.keys(itm.delivery).length && (itm.item_visibility === 'both' || itm.item_visibility === 'adhoc_item')) {
                Object.keys(itm.delivery).forEach(function (p) {
                  if (itm.delivery[p] && itm.delivery[p].quantity <= 0) {
                    return false
                  }

                  if (!isError && itm.delivery[p] && !itm.delivery[p].planned_delivery) {
                    isError = true
                    return false
                  }
                })
              }
            })
          }
        })
      }
      return isError
    },
    setPreviousQuantity(value, itm, field = null) {
      if(itm.delivery[field]) {
        itm.delivery[field].previous_quantity = value
      }
    },
    openPictureOverlay (line) {
      const self = this
      self.pictures = []
      self.pictures.push({
        src: '/storage/product/' + line.product.product_master.picture.path,
        alt: line.product.product_master.picture.name
      })
      self.$refs.imageSilentBox.openOverlay(self.pictures[0], 0)
    },
    multipleContractCheck() {
      this.multipleContract = false   
      if(this.item && this.item.contract_year && this.item.customer_external_id && !this.user.is_super_user) {
        var params = {
          customer_external_id: this.item.customer_external_id,
          contract_year: this.item.contract_year,
          contract_id: this.item.id,
          contract_type: this.item.type
        }
        let url = '/api/sandoz/gadget/contracts/check-contract-exist';
        axios.post(url, params)
        .then((response) => {
          var contractCount = response.data.contract_count
          if(contractCount > 0) { 
            this.multipleContract = true   
          }
        })
      }    
    },
    getQuarterStartDates(year) {
      if(!year || year === null) {
        return []
      }
      
      let dates = [];
      for (let q = 1; q <= 4; q++) {
        dates.push({value: moment().year(year).quarter(q).startOf('quarter').format('YYYY-MM-DD 00:00:01'), text: moment().year(year).quarter(q).startOf('quarter').format('DD.MM.YYYY')});
      }
      return dates;
    }, 
    getNextQuarterDate() {
      return moment()
        .add(1, 'quarter')
        .startOf('quarter')
        .format('YYYY-MM-DD 00:00:01');
    },
    isNotDraftContract(item) {
      if (!item) return false;

      return (
        ['Committed', 'Approved', 'Signed'].includes(item.status) &&
        item.contract_year > 2023
      );
    },
    addSubAddresses() {
      if (this.item.addresses.length > 1) {
        this.$refs.subAddressModal.show()
      }
      else {
        this.addSubAddressesImpl()
      }
    },
    clearAndAddSubAddressesImpl() {
      this.item.addresses.splice(1)
      this.addSubAddressesImpl()
    },
    addSubAddressesImpl() {
      this.$refs.subAddressModal.hide()
      this.subAddressProcessActive = true

      axios.get(`/api/sandoz/kam/contracts/get-child-addresses/${this.item.customer_external_id}`).then(response => {
        let addressCount = this.item.addresses.length
        var addresses = response.data.map(address => ({
            del_address: ++addressCount,
            address_type: 'delivery',
            company_name: address.parent.full_name,
            street: address.parent.street,
            zip: address.parent.zip_code,
            city: address.parent.city,
            customer_external_id: address.external_id,
            customer_external_id_hcp: address.external_id,
            customer_size: address.org_pharmacy_classification,
            default_customer_size: address.org_pharmacy_classification,
          }))

        this.item.addresses.push(...addresses)
        this.subAddressProcessActive = false
      })
    },
    updateExternalIDlist() {
      this.subAddressList.externalIDs = this.subAddressList.input.split(/[ ,;\n\r]+/).map(i => {return {externalID: i, feedback: ''}})
    },
    addAddressListImp() {
      var self = this
      var list = self.subAddressList.externalIDs.map(e => e.externalID)

      axios.post(`/api/sandoz/kam/contracts/get-addresses`, {externalIDs: list}).then(response => {
        response.data.forEach(address => {
          let currentRecord = self.subAddressList.externalIDs.findIndex(es => es.externalID == address.external_id)

          // check if address already exitss
          if (self.item.addresses.filter(a => a.customer_external_id == address.external_id).length > 0) {
            self.subAddressList.externalIDs[currentRecord].feedback = 'exists'
          }
          else {
            let addressCount = self.item.addresses.length
            var addressObject = {
              del_address: ++addressCount,
              address_type: 'delivery',
              company_name: address.parent.full_name,
              street: address.parent.street,
              zip: address.parent.zip_code,
              city: address.parent.city,
              customer_external_id: address.external_id,
              customer_external_id_hcp: address.external_id,
              customer_size: address.org_pharmacy_classification,
              default_customer_size: address.org_pharmacy_classification,
              items: [],
              adhoc_items: []
            }
            self.item.addresses.push(addressObject)

            self.addItemsToAddresses(false)
            self.setContractDateToItems()

            self.subAddressList.externalIDs[currentRecord].feedback = 'added'
          }
        })

        // mark all records we didn't get from our server as "not found"
        self.subAddressList.externalIDs.filter(a => a.feedback == '').forEach(e => e.feedback = 'not_found')
      })
    },
    removeAdhocItem(address, lineIndex) {
      address.adhoc_items.splice(lineIndex, 1)
      this.disableUploadButton = false
    }
  }
}
</script>

<style scoped>
td.exist_error {
  border: 1px solid red;
}
.item-table th, .item-table td {
  padding: 0 !important;
}

.ice-item-table .custom-select{
  width: 100% !important;
 }
</style>


